// ArChat Layout Fix
// Created: 12-03-2026 17:33:56
// Author: SIVOL® - Aldo Frias - Argentina

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export { LANGUAGE_ROSTER_FROM_ES } from '../../i18n/languageRoster.js';

export const translationsEs = {
                'login.title': 'Iniciar Sesión',
                'login.slogan': 'Conversaciones sin fronteras!',
                'login.username': 'Nombre de usuario',
                'login.password': 'Contraseña',
                'login.submit': 'Iniciar Sesión',
                'login.loading': 'Cargando...',
                'login.demo.title': 'Acceso demo',
                'login.demo.credentials': 'Usuario: demo / Contraseña: demo',
                'login.email.placeholder': 'Ingresa tu email para confirmar tu cuenta',
                'login.email.help': 'Se enviará un link de confirmación a tu email',
                'login.autoRegister.title': 'Registro Automático',
                'login.autoRegister.description': 'Si no tienes una cuenta, ingresa tu nombre de usuario, contraseña y email. Se creará automáticamente y se te enviará un link de confirmación a tu email.',
                'login.forgotPassword': '¿Olvidaste tu contraseña?',
                'login.passwordRecovery.title': 'Recuperar Contraseña',
                'login.passwordRecovery.description': 'Ingresa tu email para recibir un enlace de recuperación.',
                'login.passwordRecovery.emailLabel': 'Email',
                'login.passwordRecovery.emailPlaceholder': 'Ingresa tu email',
                'login.passwordRecovery.emailHelp': 'Se enviará un enlace de recuperación a tu email',
                'login.passwordRecovery.send': 'Enviar',
                'login.passwordRecovery.success': 'Se ha enviado un enlace de recuperación a tu email. Revisa tu bandeja de entrada.',
                'login.passwordRecovery.successTitle': 'Email enviado',
                'login.passwordRecovery.successMessage': 'Hemos enviado un email con las instrucciones para restablecer tu contraseña.\nRevisá tu bandeja de entrada y la carpeta de spam. El enlace puede demorar unos minutos.',
                'login.passwordRecovery.devExplanation': 'En modo desarrollo el email no se envía a tu bandeja; se guarda para previsualización. Usá "Ver email" para ver el contenido y el enlace de recuperación.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Modo desarrollo: este email NO fue enviado a tu bandeja. Usá "Ver email" para abrir el mensaje generado y usar el link.',
                'login.passwordRecovery.invalidEmail': 'Por favor, ingresa un email válido',
                'login.error.invalidPassword': 'Contraseña inválida',
                'auth.require_email': 'Se requiere email para completar el registro. Por favor, ingresá tu email.',
                'auth.invalid_credentials': 'Contraseña o usuario incorrectos.',
                'auth.user_not_found': 'Usuario no encontrado.',
                'auth.user_inactive': 'Tu cuenta está desactivada. Contactá al administrador.',
                'auth.tenant_mismatch': 'Tu cuenta no pertenece a este entorno. Contactá al administrador.',
                'auth.account_blocked': 'La cuenta está inactiva. Completá tu email para reactivarla.',
                'auth.device_limit_reached': 'Límite de dispositivos alcanzado. Cerrá sesión en otro dispositivo o mejorá tu plan.',
                'auth.login.device_limit.title': 'Límite de sesiones o dispositivos',
                'auth.login.device_limit.body': 'Tu plan permite un número limitado de sesiones o dispositivos activos. Para entrar, cerrá sesión en otro dispositivo o cerrá otra sesión abierta, e intentá de nuevo.',
                'auth.password_incorrect': 'La contraseña es incorrecta.',
                'auth.login.password_error_title': 'Contraseña incorrecta',
                'auth.login.password_attempts_hint': 'Tienes 3 oportunidades para ingresar tu contraseña correctamente. Si superas esos intentos, deberás restablecer tu contraseña.',
                'auth.login.password_attempts_exhausted_title': 'Límite de intentos alcanzado',
                'auth.login.password_attempts_exhausted_body': 'Superaste los 3 intentos permitidos. Para continuar, restablecé tu contraseña desde "¿Olvidaste tu contraseña?".',
                'auth.login.go_to_reset_password': 'Ir a restablecer contraseña',
                'auth.login.password_remaining_two': 'Te quedan 2 oportunidades.',
                'auth.login.password_remaining_one': 'Te queda 1 oportunidad.',
                'auth.login.password_attempts_locked_inline': 'Has alcanzado el máximo de intentos. Debes restablecer tu contraseña.',
                'auth.login.clear_password_lock_after_reset': 'Ya cambié mi contraseña (p. ej. en otro dispositivo)',
                'auth.account_inactive_email_mismatch': 'La cuenta está inactiva y el email no coincide.',
                'auth.captcha_failed': 'El CAPTCHA es incorrecto. Verificá tu respuesta.',
                'auth.captcha_expired': 'Tu verificación expiró. Hemos generado una nueva automáticamente.',
                'auth.captcha_required': 'Debés completar la verificación de seguridad (CAPTCHA).',
                'auth.unauthorized': 'No tenés permiso para acceder.',
                'auth.generic_error': 'Ocurrió un error. Intentá nuevamente.',
                'auth.signup_disabled': 'El registro de nuevas cuentas está deshabilitado temporalmente en este entorno.',
                'auth.method_not_allowed': 'Método no permitido.',
                'auth.invalid_data': 'Datos inválidos.',
                'auth.credentials_required': 'Usuario y contraseña son requeridos.',
                'auth.csrf_invalid': 'Tu sesión de seguridad expiró. Por favor, recargá la página e intentá de nuevo.',
                'auth.username_taken': 'Ese nick ya está registrado. Iniciá sesión o elegí otro.',
                'auth.username_unavailable': 'Ese usuario no está disponible.',
                'auth.nick_no_spaces': 'El nombre de usuario no puede contener espacios.',
                'auth.password_too_short': 'La contraseña debe tener al menos 6 caracteres.',
                'auth.password_mismatch': 'Las contraseñas no coinciden.',
                'auth.rate_limit': 'Demasiados intentos. Esperá un momento e intentá de nuevo.',
                'auth.confirm_success': 'Cuenta confirmada exitosamente. Redirigiendo al login...',
                'auth.confirm_already_active': 'Tu cuenta ya está activa. Podés iniciar sesión.',
                'auth.reset_sent': 'Si el email está registrado, recibirás instrucciones para restablecer tu contraseña.',
                'auth.reset_user_not_found': 'No encontramos una cuenta asociada a ese correo electrónico. Verificá que esté bien escrito o creá una cuenta nueva.',
                'auth.reset_token_invalid': 'Enlace inválido o faltante.',
                'auth.reset_token_expired': 'El enlace expiró. Solicitá uno nuevo desde "¿Olvidaste tu contraseña?".',
                'auth.reset_done': 'Contraseña actualizada. Ya podés iniciar sesión.',
                'auth.reset_fatal': 'Error al guardar. Intentá más tarde.',
                'resetPassword.page.title': 'Nueva contraseña',
                'resetPassword.page.description': 'Ingresá tu nueva contraseña (mínimo 6 caracteres).',
                'resetPassword.newPassword': 'Nueva contraseña',
                'resetPassword.newPasswordPlaceholder': 'Mínimo 6 caracteres',
                'resetPassword.submit': 'Restablecer contraseña',
                'resetPassword.success': 'Contraseña actualizada. Redirigiendo al login...',
                'resetPassword.backToLogin': 'Volver al login',

                'account.delete.section_title': 'Eliminar cuenta',
                'account.delete.description': 'Al eliminar tu cuenta se borrarán permanentemente todos tus datos, mensajes, contactos y configuración. Esta acción no se puede deshacer.',
                'account.delete.button': 'Eliminar mi cuenta',
                'accountDeletion.title': 'Eliminación de cuenta y datos',
                'accountDeletion.description': 'Solicitá la eliminación de tu cuenta de ArChat y de los datos asociados.',
                'accountDeletion.openRequest': 'Solicitar eliminación de cuenta y datos',
                'account.delete.confirm_title': 'Eliminar cuenta',
                'account.delete.confirm_message': '¿Estás seguro de que querés eliminar tu cuenta? Se enviará un email de confirmación a tu casilla. La eliminación es permanente e irreversible.',
                'account.delete.email_sent_title': 'Email enviado',
                'account.delete.email_sent': 'Te enviamos un email de confirmación. Revisá tu casilla y hacé clic en el enlace para confirmar la eliminación.',
                'account.delete.error': 'No se pudo procesar la solicitud. Intentá nuevamente.',
                'account.delete.confirm_page_title': 'Confirmar eliminación de cuenta',
                'account.delete.confirm_page_desc': 'Estás a punto de eliminar permanentemente tu cuenta de ArChat. Se borrarán todos tus datos, mensajes, contactos y configuración. Esta acción no se puede deshacer.',
                'account.delete.confirm_final_button': 'Sí, eliminar mi cuenta permanentemente',
                'account.delete.cancel_go_back': 'Cancelar y volver',
                'account.delete.done_title': 'Cuenta eliminada',
                'account.delete.done_message': 'Tu cuenta ha sido eliminada correctamente. Todos tus datos fueron borrados.',
                'account.delete_token_expired': 'El enlace de eliminación venció o ya no es válido. Solicitá uno nuevo desde tu perfil.',
                'account.delete_token_invalid': 'Enlace de eliminación inválido o faltante.',
                'account.delete_email_failed': 'No se pudo enviar el email de confirmación. Intentá más tarde.',
                'account.delete_error': 'Error al procesar la eliminación. Intentá más tarde.',
                'account.not_found': 'Cuenta no encontrada.',

                'mail.send_failed': 'No se pudo enviar el email de recuperación. Revisa la configuración SMTP o intenta más tarde.',
                'auth.register_success_email_sent': 'Cuenta creada exitosamente. Se ha enviado un email de confirmación. Revisa tu bandeja de entrada (y la carpeta de spam) y haz clic en el enlace para activar tu cuenta.',
                'auth.register_success_email_pending': 'Cuenta creada exitosamente, pero hubo un problema al enviar el email de confirmación. El token de activación sigue siendo válido. Contacta al administrador o solicita un nuevo email de confirmación.',
                'auth.email_not_verified': 'Debés confirmar tu email para activar la cuenta.',
                'auth.email_not_verified_title': 'Cuenta pendiente de confirmación',
                'auth.email_send_failed': 'No pudimos enviar el email ahora. Reintentá o cambiá el email.',
                'auth.email_send_failed_title': 'No pudimos enviar el email',
                'auth.register.email_failed.title': 'Cuenta creada',
                'auth.register.email_failed.message': 'Tu cuenta fue creada correctamente, pero hubo un problema al enviar el email de confirmación. Revisá spam o solicitá un nuevo email.',
                'auth.register.success.title': 'Cuenta creada',
                'auth.register.success.message': 'Cuenta creada exitosamente. Se ha enviado un email de confirmación. Revisa tu bandeja de entrada (y la carpeta de spam) y haz clic en el enlace para activar tu cuenta.',
                'auth.resend_sent': 'Email de confirmación reenviado.',
                'auth.resend_activation': 'Reenviar email de activación',
                'auth.pending_activation.title': 'Cuenta pendiente de activación',
                'auth.pending_activation.body': 'Tu cuenta todavía no está activada. Revisá tu correo y confirmá tu registro para poder ingresar a ArChat.',
                'auth.pending_activation.back_to_login': 'Volver al login',
                'auth.pending_activation.support_prefix': '¿Necesitás ayuda? Contactá soporte:',
                'auth.pending_activation.support_email': 'info@archat.com.ar',
                'auth.pending_activation.email_label': 'Correo para reenviar la activación',
                'auth.pending_activation.email_placeholder': 'tu@email.com',
                'auth.pending_activation.email_required': 'Ingresá el correo con el que te registraste para reenviar la activación.',
                'auth.pending_activation.sent_title': 'Email de activación enviado',
                'auth.pending_activation.sent_body': 'Si el correo corresponde a una cuenta pendiente, te enviamos un nuevo enlace de activación. Revisá tu bandeja de entrada y también spam o correo no deseado.',
                'auth.pending_activation.soft_error_title': 'Reenvío no disponible',
                'auth.pending_activation.soft_error_body': 'No pudimos procesar el reenvío en este momento. Intentá nuevamente en unos minutos o escribinos a info@archat.com.ar.',
                'auth.pending_activation.resend_again': 'Reenviar nuevamente',
                'auth.resend_email': 'Reenviar email',
                'auth.retry_resend': 'Reintentar',
                'auth.change_email': 'Cambiar email',
                'auth.ver_email': 'Ver email',
                'auth.already_verified': 'La cuenta ya está verificada.',
                'auth.confirm_email_title': 'Confirmar email',
                'auth.confirm_email_text': 'Se enviará el enlace de activación a:',
                'auth.confirm_email_edit': 'Editar',
                'auth.confirm_email_confirm': 'Confirmar',
                'auth.confirm_email_typo_hint': '¿Quisiste decir ***@{suggestion}?',
                'brand.slogan': 'El poder de ser comprendido, sin importar el lenguaje',
                'brand.appName': 'ArChat®',
                'brand.name': 'ArChat®',
                'home.title': 'ArChat®',
                'home.slogan': 'El poder de ser comprendido, sin importar el lenguaje',
                'home.tagline': 'Mensajería con traducción automática',
                'home.login': 'Iniciar sesión',
                'home.register': 'Crear cuenta',
                'home.language': 'Idioma',
                'auth.tagline': 'El poder de ser comprendido, sin importar el lenguaje',
                'auth.sign_in': 'Iniciar sesión',
                'auth.create_account': 'Crear cuenta',
                'ui.search_contact': 'Buscar contacto',
                'ui.language': 'Idioma',
                'terms.title': 'Términos y Condiciones',
                'terms.accept': 'Aceptar y Continuar',
                'terms.reject': 'Rechazar',
                'terms.rejectShort': 'No acepto',
                'terms.readAndAccept': 'He leído y acepto los Términos y Condiciones',
                'terms.cancel': 'Cancelar',
                'register.pageTitle': 'Crear cuenta',
                'register.pageSubtitle': 'Completá tus datos para crear tu cuenta.',
                'register.submitLabel': 'Crear cuenta',
                'register.confirm_title': 'Confirmar cuenta',
                'register.confirm_message': 'Vas a crear la cuenta:',
                'register.confirm': 'Confirmar',
                'register.creatingAccount': 'Creando tu cuenta…',
                'register.login_link': '¿Ya tenés cuenta?',
                'register.password_hint': 'Mínimo 6 caracteres',
                'register.checking': 'Verificando…',
                'register.username_taken': 'Este usuario ya está en uso.',
                'register.available': 'Disponible',
                'register.emailAlreadyExists': 'Este email ya está registrado.',
                'register.continue': 'Continuar',
                'common.language': 'Idioma',
                'common.loading': 'Cargando…',
                'common.edit': 'Editar',
                'common.on': 'Activado',
                'common.off': 'Desactivado',
                'common.back': 'Volver',
                'common.backToStart': 'Volver al inicio',
                'common.changeUser': 'Cambiar usuario',
                'common.refresh': 'Actualizar',
                'common.request_id_label': 'ID de solicitud',
                'login.email.invalid': 'Por favor, ingresa un email válido',
                'system.processing': 'Procesando...',
                'captcha.label': 'Verificación de seguridad',
                'security.verification_title': 'Verificación de seguridad',
                'security.captcha_question': 'Pregunta de verificación',
                'security.enter_answer': 'Ingresa la respuesta',
                'captcha.description': 'Por favor resuelve la operación para continuar.',
                'captcha.required': 'Debés ingresar la respuesta del CAPTCHA para continuar.',
                'captcha.solve': 'Por favor, resolvé el CAPTCHA correctamente',
                'captcha.incorrect': 'La respuesta del captcha es incorrecta.',
                'captcha.placeholder': 'Escribe la respuesta',
                'captcha.questionFormat': '¿Cuánto es {a} + {b}?',
                'captcha.generateError': 'No se pudo cargar el CAPTCHA (posible bloqueo HTTPS, cookies o sesión). Recargá la página o probá otro navegador.',
                'menu.conversations': 'Conversaciones',
                'menu.contacts': 'Contactos',
                'menu.dashboard': 'Dashboard',
                'menu.admin': 'Administración',
                'menu.profile': 'Mi Perfil',
                'menu.settings': 'Configuración',
                'menu.help': 'Ayuda',
                'menu.promotions': 'Promociones',
                'menu.plans': 'Planes',
                'menu.logout': 'Salir',

                // MVP "Mis archivos"
                'menu.files': 'Mis archivos',
                'files.title': 'Mis archivos',
                'files.filter_all': 'Todos',
                'files.filter_sent': 'Enviados',
                'files.filter_received': 'Recibidos',
                'files.filter_images': 'Imágenes',
                'files.filter_documents': 'Documentos',
                'files.col_name': 'Nombre',
                'files.col_size': 'Tamaño',
                'files.col_date': 'Fecha',
                'files.col_direction': 'Dir.',
                'files.col_actions': 'Acciones',
                'files.sent': '📤 Enviado',
                'files.received': '📥 Recibido',
                'files.download': 'Descargar',
                'files.delete_for_me': 'Eliminar para mí',
                'files.delete_confirm_title': 'Eliminar archivo',
                'files.delete_confirm_message': 'Este archivo se eliminará de tu cuenta. No se borrará para la otra persona. ¿Continuar?',
                'files.empty': 'No tienes archivos.',
                'files.error_loading': 'Error al cargar archivos.',
                'files.unavailableForFree': 'Mis archivos no está incluido en el plan FREE.',
                'files.availableInFoundationAndPro': 'Mis archivos está disponible en FOUNDATION y PRO.',
                'files.filesFeatureRestricted': 'Esta función no está disponible en tu plan actual.',
                'files.filesLoadError': 'Error al cargar archivos.',
                'files.uploadUnavailableForFree': 'Enviar archivos no está disponible en el plan FREE.',
                'files.uploadAvailableInFoundationAndPro': 'El envío de archivos está disponible en FOUNDATION y PRO.',
                'files.recipientStorageFull': 'El destinatario no tiene espacio disponible para recibir este archivo.',
                'files.recipientNoAvailableStorage': 'El destinatario no tiene espacio disponible para recibir este archivo.',
                'files.storageQuotaExceeded': 'Has alcanzado el límite de almacenamiento de tu plan.',
                'files.freeStorageLimit': 'Tu plan FREE incluye 5 MB de almacenamiento para archivos recibidos.',
                'files.load_more': 'Cargar más',
                'navbar.contacts': 'Contactos',
                'navbar.profile': 'Mi Perfil',
                'navbar.settings': 'Configuración',
                'navbar.logout': 'Salir',
                'navbar.status': 'Estado',
                'navbar.users': 'Usuarios',
                'navbar.no_blocked_users': 'No hay usuarios bloqueados',
                'navbar.blocked_users_title': 'Usuarios bloqueados',
                'contacts.blocked_users_title': 'Usuarios bloqueados',
                'contacts.country_label': 'País',
                'contacts.not_reported': 'No informado',
                'navbar.user_fallback': 'Usuario {id}',
                'navbar.open_guide': 'Guía',
                'profile.my_profile': 'Mi Perfil',
                'profile.status': 'Estado',
                'profile.invite_email': 'Invitar Contacto por Email',
                'profile.sent_invitations': 'Invitaciones Enviadas',
                'profile.users': 'Usuarios',
                'profile.settings': 'Configuración',
                'profile.appearance': 'Apariencia',
                'profile.logout': 'Salir',
                'help.view_initial_guide': 'Ver guía inicial',
                'help.how_archat_works': 'Cómo funciona ArChat®',
                'help.registration': 'Registro',
                'help.private_invitations': 'Invitaciones privadas',
                'help.messaging': 'Mensajería',
                'help.security': 'Seguridad',
                'contacts.invite_contact': 'Invitar contacto',
                'contacts.no_contacts': 'No hay contactos',
                'invitation.quick_button': 'Invitar contacto',
                'onboarding.title': 'Bienvenido a ArChat®',
                'onboarding.subtitle': 'Comunícate con cualquier persona en cualquier idioma.',
                'onboarding.step1.label': 'Paso 1',
                'onboarding.step1.text': 'Invita tu primer contacto',
                'onboarding.step2.label': 'Paso 2',
                'onboarding.step2.text': 'Envía tu primer mensaje',
                'onboarding.actions.invite': 'Invitar contacto',
                'onboarding.actions.explore': 'Explorar ArChat®',
                'onboarding.welcome_title': 'Bienvenido a ArChat®',
                'onboarding.welcome_subtitle': 'Comunícate con cualquier persona en cualquier idioma.',
                'onboarding.step1': 'Paso 1',
                'onboarding.step1_title': 'Paso 1',
                'onboarding.step1_description': 'Invita tu primer contacto',
                'onboarding.step2': 'Paso 2',
                'onboarding.step2_title': 'Paso 2',
                'onboarding.step2_description': 'Envía tu primer mensaje',
                'onboarding.invite_contact': 'Invitar contacto',
                'onboarding.explore_archat': 'Explorar ArChat®',
                'suggestions.title': 'Sugerencias',
                'suggestions.form.title': 'Título de la sugerencia',
                'suggestions.form.message': 'Describe tu idea',
                'suggestions.form.submit': 'Enviar sugerencia',
                'suggestions.success': 'Gracias por tu sugerencia. Nuestro equipo la revisará.',
                'suggestions.success.title': '¡Gracias por tu sugerencia!',
                'suggestions.success.reference': 'Referencia',
                'suggestions.success.review': 'Nuestro equipo revisará tu idea.',
                'suggestions.success.email': 'También te hemos enviado un email de confirmación.',
                'suggestions.success.copy': 'Copiar',
                'suggestions.success.copied': 'Referencia copiada',
                'suggestions.form.required': 'Título y mensaje son obligatorios.',
                'suggestions.error': 'No se pudo enviar. Intenta de nuevo.',
                'suggestions.send': 'Enviar sugerencia',
                'suggestions.captcha_placeholder': 'Resultado',
                'suggestions.cooldown': 'Debe esperar {minutes} minutos antes de enviar otra sugerencia.',
                'suggestions.success_title': 'Sugerencia enviada',
                'suggestions.success_message': 'Tu sugerencia fue enviada correctamente. Número de seguimiento: {id}',
                'suggestions.sendSuccess': 'Tu sugerencia fue enviada correctamente.',
                'suggestions.sendError': 'No se pudo enviar la sugerencia. Intenta nuevamente.',
                'suggestions.sent': 'La sugerencia fue enviada correctamente.',
                'suggestions.new': 'Nueva sugerencia',
                'suggestions.empty': 'Aún no tienes sugerencias enviadas.',
                'suggestions.admin_note': 'Nota del equipo',
                'suggestions.status.pending': 'Pendiente',
                'suggestions.status.reviewed': 'Revisada',
                'suggestions.status.planned': 'Planificada',
                'suggestions.status.implemented': 'Implementada',
                'suggestions.status.rejected': 'Rechazada',
                'referral.promo': 'Invitá y ganá 10.000 caracteres',
                'referral.stats.sent': 'Enviadas',
                'referral.stats.accepted': 'Aceptadas',
                'referral.stats.rewards': 'Recompensas',
                'referral.reward.pending': 'Pendiente',
                'referral.reward.granted': 'Completado',
                'referral.reward.invalid': 'No válido',
                'referral.reward.in_progress': 'En uso',
                'referral.limit.reached': 'Límite de recompensas alcanzado',
                'referral.waiting.usage': '+10.000 caracteres para cada uno cuando vos y tu invitado envíen al menos un mensaje de texto real en el mismo chat (validado en servidor).',
                'promotions.title': 'Promociones y recompensas',
                'promotions.subtitle': 'Invitá contactos y activá beneficios con uso real.',
                'promotions.how_it_works': 'Cómo funciona',
                'promotions.step1': 'Invitá un contacto desde tu perfil.',
                'promotions.step2': 'Cuando acepte y converse de forma real, se valida automáticamente.',
                'promotions.step3': 'Se acredita la recompensa y se actualiza tu progreso.',
                'promotions.rewards.title': 'Recompensas',
                'promotions.reward.invite': 'Recompensa por invitación validada.',
                'promotions.reward.milestone': 'Bonificaciones por hitos de crecimiento.',
                'promotions.reward.ranking': 'Visibilidad en ranking de constructores de red.',
                'promotions.progress.title': 'Tu progreso',
                'promotions.progress.sent': 'Enviados',
                'promotions.progress.pending': 'Tenés invitaciones pendientes para activar ganancias.',
                'promotions.progress.in_progress': 'Tus invitaciones están en uso: la recompensa se acredita al completar una conversación real.',
                'promotions.progress.remaining': 'Te falta {count} conversación para recibir tu recompensa.',
                'promotions.progress.sent_count': 'Enviados',
                'promotions.progress.pending_count': 'Pendientes',
                'promotions.progress.in_progress_count': 'En uso',
                'promotions.progress.completed_count': 'Completados',
                'promotions.cta.invite': 'Invitar contacto',
                'promotions.cta.copy': 'Copiar mensaje y link',
                'promotions.cta.copied': 'Mensaje copiado',
                'promotions.cta.copy_error': 'No se pudo copiar el mensaje',
                'promotions.invite.message': 'Te invito a ArChat — hablá en cualquier idioma. Ambos ganamos beneficios.',
                'promotions.banner': 'Activá promociones: invitá y ganá recompensas por uso real.',
                'promotions.banner.empty': 'Empezá hoy: invitá contactos y desbloqueá beneficios.',
                'promotions.banner.pending': 'Tenés invitaciones pendientes: completá una conversación y ganá recompensas.',
                'promotions.banner.reward': '¡Ya tenés recompensas activadas! Seguí invitando para más ganancias.',
                'promotions.modal.title': 'Programa de promociones',
                'promotions.modal.body': 'Ganás +10.000 caracteres por referido cuando exista un chat real de ida y vuelta validado (ver reglas del programa).\nInvitá hoy y activá tus recompensas.',
                'promotions.modal.cta': 'Ver promociones',
                'errors.suggestionSend': 'No se pudo enviar la sugerencia. Intenta nuevamente.',
                'common.sending': 'Enviando...',
                'app.install': 'Instalar ArChat',
                'app.install_ios_hint': 'Para instalar: Compartir > Agregar a pantalla de inicio',
                'menu.open': 'Menú',
                'contacts.controls.hide_non_favorites': 'Ocultar contactos no favoritos',
                'contacts.controls.show_all': 'Mostrar todos los contactos',
                'common.navigation': 'Navegación',
                'common.favorite': 'Favorito',
                'common.block': 'Bloquear',
                'common.user': 'Usuario',
                'common.avatar': 'Avatar',
                'message.new': 'Mensaje nuevo',
                'message.edit': 'Editar mensaje',
                'message.edit.save': 'Guardar edición',
                'message.edit.cancel': 'Cancelar edición',
                'message.translating': 'Traduciendo...',
                'message.translation_failed': 'No se pudo traducir',
                'message.not_translated': 'Texto original',
                'message.retry_send': 'Reintentar',
                'message.status.sending': 'Enviando…',
                'message.status.failed': 'No enviado',
                'message.status.sent': 'Enviado',
                'message.status.delivered': 'Entregado',
                'message.status.read': 'Leído',
                'message.retrying': 'Reintentando...',
                'message.delete': 'Eliminar mensaje',
                'message.deleted_placeholder': 'Mensaje eliminado',
                'message.edited': 'Editado',
                'message.edited_at': 'Editado el',
                'message.delete_for_me.tooltip': 'Borrar para mí',
                'message.delete_for_me.aria': 'Borrar este mensaje solo para mí',
                'message.delete_for_me.confirm_title': 'Borrar mensaje',
                'message.delete_for_me.confirm_message': 'Este mensaje se borrará para vos y liberará el espacio de este adjunto en tu plan.',
                'message.delete_for_everyone.tooltip': 'Borrar para todos',
                'message.delete_for_everyone.aria': 'Borrar este mensaje para todos los participantes',
                'message.delete_for_everyone.confirm_title': 'Borrar mensaje para todos',
                'message.delete_for_everyone.confirm_message': 'Este mensaje se borrará para vos y para el otro participante.',
                'message.delete_for_everyone.window_expired': 'Ventana de borrado vencida',
                'message.translation.show': 'Ver original y traducción',
                'message.translation.hide': 'Ocultar traducción',
                'emoji.search': 'Buscar emoji',
                'emoji.close': 'Cerrar selector',
                'captcha.refresh': 'Regenerar CAPTCHA',
                'presence.unavailable': 'Estados no disponibles',
                'presence.maintenance': 'Servidor en mantenimiento',
                'home.access_nav': 'Acceso a la aplicación',
                'home.public_nav.pricing': 'Precios',
                'home.public_nav.aria': 'Navegación principal del sitio',
                'home.public_footer.aria': 'Enlaces legales',
                'home.pricing_link': 'Planes y precios',
                'publicPricing.nav.back_home': '← Inicio',
                'publicPricing.title': 'Planes y precios',
                'publicPricing.subtitle': 'Límites transparentes y alineados al motor de suscripciones de ArChat. Precios comerciales en USD para checkout internacional (p. ej. Paddle).',
                'publicPricing.commercial_note': 'Los límites funcionales provienen de PlanConstants / PlanResolver; tu cuenta puede aplicar plan_limits en base de datos. El cobro comercial usa Paddle (u otros procesadores oficialmente designados por ArChat) con precios USD como se indica.',
                'publicPricing.plan.free': 'FREE',
                'publicPricing.plan.foundation': 'FOUNDATION',
                'publicPricing.plan.pro': 'PRO',
                'publicPricing.price.free': 'USD 0 / mes',
                'publicPricing.price.foundation': 'USD {price} / mes',
                'publicPricing.price.pro': 'USD {price} / mes',
                'publicPricing.same_limits_pro': 'Mismos límites técnicos que PRO (contrato premium).',
                'publicPricing.same_limits_foundation': 'Mismos límites técnicos que FOUNDATION (contrato premium).',
                'publicPricing.badge.foundation': 'Programa Founder',
                'publicPricing.badge.pro': 'Recomendado',
                'publicPricing.free.b1': '30.000 caracteres por mes por cuenta.',
                'publicPricing.free.b2': 'Hasta 2 contactos por usuario; hasta 2 conversaciones activas por cuenta.',
                'publicPricing.free.b3': 'Sin archivos adjuntos ni espacio de almacenamiento; sin exportación de datos.',
                'publicPricing.free.b4': 'Historial de mensajes hasta 30 días; 1 dispositivo por usuario.',
                'publicPricing.free.b5': '34 mensajes/día y 1.000 mensajes/mes (tenant); hasta 20 invitaciones por día.',
                'publicPricing.premium.b1': '300.000 caracteres por mes por cuenta; hasta 100 contactos por usuario.',
                'publicPricing.premium.b2': 'Conversaciones y chats ilimitados (tenant); 1.667 mensajes/día y 50.000/mes.',
                'publicPricing.premium.b3': 'Hasta 50 MB de almacenamiento (tenant); hasta 3 dispositivos por usuario.',
                'publicPricing.premium.b4': 'Invitaciones ilimitadas (tenant); exportación, traducción automática y archivos según plan.',
                'publicPricing.premium.b5': 'FOUNDATION: mismo contrato técnico que PRO, más programa Founder (150 plazas). PRO: premium estándar.',
                'publicPricing.foundation.founder_note': 'Programa comercial Founder: cupo limitado de {slots} plazas (ver resumen de plan). Mismos límites PRO una vez activada la suscripción.',
                'publicPricing.cta.start_free': 'Crear cuenta gratis',
                'publicPricing.cta.register_paid': 'Crear cuenta',
                'publicPricing.paddle_hint': 'El checkout con el procesador elegido se completará dentro de la aplicación cuando el cobro esté habilitado.',
                'publicPricing.legal.nav_label': 'Legal',
                'publicPricing.legal.terms': 'Términos del servicio',
                'publicPricing.legal.privacy': 'Política de privacidad',
                'publicPricing.legal.refund': 'Política de reembolsos',
                'common.requiredFields': 'Completa todos los campos obligatorios.',
                'bio.view': 'Ver biografía',
                'bio.modal.original': 'Original',
                'bio.modal.translation': 'Traducción',
                'bio.modal.empty': 'Este contacto no tiene biografía.',
                'bio.modal.translating': 'Traduciendo...',
                'bio.modal.translation_error': 'No se pudo traducir la biografía.',
                'attachment.unnamed_file': 'Archivo',
                'auth.login_error.default_title': 'Error de acceso',
                'auth.login_error.default_message': 'No se pudo iniciar sesión',
                'profile.title': 'Mi Perfil',
                'profile.founderBadge': 'Fundador #{position}/{limit}',
                'profile.founderTooltip': 'Miembro Fundador – Precio congelado de por vida mientras la suscripción permanezca activa',
                'profile.founderMember': 'Miembro Fundador',
                'profile.founderHeaderBadge': '★ Fundador #{position}/150',
                'profile.camera.access_denied': 'No se pudo acceder a la cámara. Verificá los permisos.',
                'profile.edit': 'Editar',
                'profile.save': 'Guardar Cambios',
                'profile.save.success': 'Tu perfil se ha actualizado correctamente.',
                'profile.save.success.title': 'Perfil Actualizado',
                'profile.update.success.title': 'Perfil Actualizado',
                'profile.update.success.message': 'Tus cambios se guardaron correctamente.',
                'profile.save.error': 'No se pudo actualizar el perfil. Por favor, intenta nuevamente.',
                'profile.save.error.title': 'Error al Guardar',
                'profile.cancel': 'Cancelar',
                'profile.nick': 'Nombre de usuario',
                'profile.nick.help': 'Tu identificador único en el sistema',
                'profile.nick.readonly': 'El nombre de usuario no se puede modificar',
                'profile.nick.readonly.help': 'El nombre de usuario es único y no se puede modificar',
                'profile.email.readonly': 'El email no se puede modificar',
                'profile.email.readonly.help': 'El email es único y no se puede modificar',
                'profile.name': 'Nombre Real',
                'profile.lastname': 'Apellido',
                'profile.alias': 'Alias',
                'profile.email': 'Email',
                'profile.phone': 'Teléfono',
                'profile.language': 'Idioma',
                'profile.country': 'País',
                'profile.country.select': 'Seleccionar país',
                'profile.biography': 'Biografía',
                'profile.photo': 'Foto de Perfil',
                'profile.plan.title': 'Plan de Suscripción',
                'profile.notifications.sound': 'Sonido de mensajes',
                'profile.notifications.sound_desc': 'Reproducir sonido cuando lleguen mensajes o alertas importantes',
                'profile.security.privacy_note': 'Gestioná la privacidad y seguridad de tu cuenta.',
                'profile.security.sessions_title': 'Sesiones activas',
                'profile.security.current': 'Sesión actual',
                'notifications.bell.aria': 'Notificaciones',
                'notifications.panel.title': 'Notificaciones',
                'notifications.empty': 'No hay notificaciones',
                'notifications.mark_read': 'Marcar como leída al abrir',
                'profile.invitations.title': 'Invitaciones',
                'profile.invitations.validated': 'Invitaciones validadas',
                'profile.invitations.nextBadge': 'Próximo logro',
                'profile.invitations.progress': 'Progreso',
                'profile.invitations.achievement': 'Logro',
                'profile.invitations.topInviterAchieved': 'Máximo Invitador alcanzado',
                'profile.invitations.badges.networkBuilder': 'Constructor de Red',
                'profile.invitations.badges.topInviter': 'Máximo Invitador',
                'profile.invitations.achievement.networkBuilderMessage': 'Invitaste a 20 usuarios en ArChat.',
                'profile.invitations.achievement.topInviterMessage': 'Invitaste a 50 usuarios en ArChat.',
                'profile.plan.current': 'Tu Plan Actual',
                'profile.plan.expires': 'Vence el',
                'profile.plan.loading_info': 'Cargando información del plan...',
                'profile.plan.valid_until': 'Válido hasta:',
                'profile.plan.active_since': 'Activo desde:',
                'profile.plan.active_badge': '✓ Activo',
                'profile.plan.free.description': 'Plan gratuito con los límites del motor FREE (alineados a /pricing). Podés pasar a FOUNDATION (Founder) o PRO cuando el cobro esté habilitado.',
                'profile.plan.foundation.description': 'Plan FOUNDATION (Founder): mismo uso premium que PRO, con programa Founder y cupo limitado (150 plazas).',
                'profile.plan.pro.description': 'Plan PRO: acceso premium estándar con los límites del motor (alineados a /pricing).',
                'profile.plan.upgrade.button': 'Actualizar a PRO',
                'profile.plan.upgrade.hint': 'Más capacidad con FOUNDATION o PRO cuando el cobro esté habilitado',
                'profile.manage_plan': 'Gestionar plan',
                'plan.current_plan': 'Plan actual',
                'plan.current': 'Actual',
                'plan.footer_prefix': 'Plan:',
                'plan.upgrade_to_pro': 'Actualizar a PRO',
                'plan.upgrade_to_foundation': 'Actualizar a FOUNDATION',
                'plans.upgrade.title': 'Actualizar plan',
                'plans.upgrade.comparison': 'Comparación de planes',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'Cancela cuando quieras',
                'plans.actions.upgrade_pro': 'Pasar a PRO',
                'plans.actions.become_founder': 'Convertirse en fundador',

                'plans.modal.card.current_badge': 'Tu plan actual',

                'plans.modal.card.lower_tier': 'Por debajo de tu plan activo',

                'plans.modal.card.manage_in_profile': 'Para cambiar o cancelar, usá Suscripción y facturación en tu perfil.',
                'plans.modal.card.cancel_subscription': 'Cancelar suscripción',
                'plans.modal.cancel_confirm.title': 'Cancelar o gestionar suscripción',
                'plans.modal.cancel_confirm.body': 'Se abrirá una nueva pestaña con el portal seguro de Paddle. Allí podés actualizar el método de pago, ver facturas o cancelar la suscripción.',
                'plans.modal.cancel_confirm.continue_button': 'Continuar',
                'plans.modal.cancel_confirm.back_button': 'Volver',
                'plans.modal.cancel_paddle_fallback.title': 'Gestionar tu suscripción',
                'plans.modal.cancel_paddle_fallback.body': 'En este entorno no abrimos el portal de Paddle (por ejemplo, desarrollo local o cuenta aún sin vincular a facturación). Igual podés seguir viendo y comparando planes en esta pantalla.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Entendido',
                'plans.upgrade_required': 'Disponible en plan PRO',
                'plan.payment_coming': 'El pago con Paddle estará disponible pronto. Podrás cambiar de plan desde aquí.',
                'plan.payment_coming_title': 'Próximamente',
                'plan.foundation_full': 'El cupo FOUNDATION está completo (150 founders). Podés elegir PRO.',
                'plan.sold_out': 'Agotado',
                'plan.founder_spots_remaining': 'Solo quedan {count} lugares disponibles',
                'plan.founders_occupied': 'founders ocupados',
                'plan.upgrade_not_allowed': 'Solo usuarios con plan FREE pueden solicitar upgrade.',
                'plan.free_contacts': 'Hasta 2 contactos',
                'plan.free_no_files': 'Sin archivos',
                'plan.free_retention': 'Historial 30 días',
                'plan.pro_files': 'Archivos hasta 50MB',
                'plan.pro_export': 'Exportación',
                'plan.founder_support': 'Prioridad soporte',
                'plan.founder_badge': 'Badge fundador',
                'founder.activeCountLabel': 'Founders activos',
                'billing.change_plan': 'Cambiar de plan',
                'billing.usage.title': 'Uso del plan',
                'billing.usage.users': 'Usuarios',
                'billing.usage.messages': 'Mensajes (hoy)',
                'billing.usage.invitations': 'Invitaciones (hoy)',
                'billing.usage.messages_month': 'Mensajes este mes',
                'billing.usage.chats': 'Conversaciones',
                'billing.usage.contacts': 'Contactos',
                'billing.usage.chars_month': 'Caracteres por mes',
                'billing.usage.storage': 'Almacenamiento usado',
                'billing.usage.devices': 'Dispositivos conectados',
                'billing.usage.warning': 'Te acercás al límite de tu plan. Actualizá a FOUNDATION o PRO para más capacidad.',
                'plans.limit.reached': 'Límite alcanzado — Mejorar plan',
                'billing.loading': 'Cargando...',
                'billing.view_plans': 'Ver planes',
                'billing.subscription.section_title': 'Suscripción y facturación',
                'billing.subscription.provider_note': 'Proveedor',
                'billing.subscription.paddle_active': 'Paddle (plan activo en la app)',
                'billing.subscription.mp_action_ok': 'Solicitud registrada. Si no se abrió el checkout, revisá tu conexión o intentá de nuevo.',
                'billing.paddle.manage_subscription_button': 'Gestionar suscripción',
                'billing.paddle.cancel_via_portal': 'Cancelar suscripción',
                'billing.paddle.portal_confirm_title': 'Portal de facturación',
                'billing.paddle.portal_confirm': 'Se abrirá el portal seguro de Paddle para actualizar método de pago, facturas o cancelar la suscripción. ¿Continuar?',
                'billing.paddle.portal_opened_hint': 'Se abrió el portal de Paddle en una nueva pestaña. Al volver, recargá el perfil si el plan no se actualizó.',
                'billing.paddle.portal_error': 'No se pudo abrir el portal de Paddle. Intentá de nuevo más tarde o contactá soporte.',
                'billing.paddle.test_access_denied_body': 'En este servidor las operaciones de facturación están restringidas (modo prueba o lista de test). Si ya pagaste con cuenta real, en producción debe permitirse el cobro para todos los usuarios (p. ej. PAYMENTS_ALLOW_ALL_BILLING_USERS) o desactivarse esa restricción. Contactá soporte.',
                'billing.paddle.no_link_error': 'Aún no hay vínculo de suscripción Paddle en tu cuenta. Si acabás de pagar, esperá unos minutos al webhook o contactá soporte.',
                'billing.paddle.api_not_configured': 'El servidor no tiene configurada la API de Paddle (PADDLE_API_KEY). El administrador debe configurarla.',
                'billing.descriptions.contacts': 'Total de contactos almacenados en tu cuenta',
                'billing.descriptions.storage': 'Almacenamiento usado para archivos y medios',
                'billing.descriptions.chars_month': 'Caracteres traducidos este mes',
                'billing.descriptions.devices': 'Dispositivos activos conectados',
                'billing.paddle.return_title': 'Pago recibido',
                'billing.paddle.return_body': 'Si completaste el checkout, tu plan se actualizará en breve cuando Paddle confirme el pago. No cierres la sesión; podés volver al inicio.',
                'billing.paddle.verifying': 'Verificando tu plan…',
                'billing.paddle.not_logged_in': 'Iniciá sesión para ver el estado actualizado de tu plan.',
                'billing.paddle.plan_updated': 'Plan actualizado correctamente: {plan}',
                'billing.paddle.plan_current': 'Tu plan actual: {plan}',
                'billing.paddle.plan_current_founder': 'Ahora eres Founder — {plan}',
                'billing.paddle.still_free_hint': 'Si seguís en FREE tras unos segundos, el webhook puede estar demorado. Revisá los logs del backend o actualizá esta página.',
                'billing.paddle.pro_extra_hint': 'Podés volver al inicio para usar tu plan.',
                'profile.theme.dark': 'Modo Oscuro',
                'profile.theme.light': 'Modo Claro',
                'profile.theme.argentina': 'Tema Argentina',
                'modal.title': 'Título',
                'modal.success.title': 'Éxito',
                'modal.error.title': 'Error',
                'modal.warning.title': 'Advertencia',
                'info.title': 'Información',
                'appearance.title': 'Apariencia',
                'appearance.theme.light': 'Claro',
                'appearance.theme.dark': 'Oscuro',
                'theme.title': 'Tema',
                'theme.light': 'Claro',
                'theme.dark': 'Oscuro',
                'profile.photo.section': 'Foto de Perfil',
                'profile.personalInfo': 'Información Personal',
                'profile.preferences': 'Preferencias',
                'profile.photo.change': 'Cambiar foto de perfil',
                'message.placeholder': 'Escribe un mensaje...',
                'message.placeholderWithFile': 'Enviar archivo',
                'message.sent_from_country': 'Enviado desde',
                'message.sent_at_local_time': 'Hora local del emisor',
                'message.timezone_label': 'Zona horaria',
                'message.context_info': 'Este mensaje conserva el contexto horario del momento en que fue enviado.',
                'message.context_pro_hint': 'Este mensaje tiene contexto horario y geográfico disponible en planes Pro.',
                'message.context_pro_badge': 'Contexto Pro',
                'messages.empty': 'No hay mensajes aún',
                'messages.loading': 'Cargando mensajes...',
                'messages.connecting_server': 'Conectando al servidor de mensajes...',
                'messages.pending_send_count': '{count} mensaje(s) esperando envío',
                'attachment.title': 'Adjuntar Archivo',
                'attachment.close': 'Cerrar',
                'attachment.gallery': 'Galería de fotos/videos',
                'attachment.cameraFront': 'Cámara frontal',
                'attachment.cameraBack': 'Cámara trasera',
                'attachment.cameraWeb': 'Cámara web',
                'attachment.selectFile': 'Seleccionar archivo (PDF, texto, imágenes, videos)',
                'attachment.remove': 'Eliminar',
                'attachment.audioNotSupported': 'Los mensajes de audio no son compatibles con ArChat®. Por favor, envía un mensaje escrito.',
                'attachment.storage_insufficient_precheck.title': 'Espacio insuficiente',
                'attachment.storage_insufficient_precheck.message': 'El archivo pesa {fileSizeMb} MB y solo tenés {availableMb} MB disponibles. Liberá espacio o mejorá tu plan para continuar.',
                'attachment.files_disabled.title': 'Límite del plan',
                'attachment.files_disabled.message': 'Tu plan actual no incluye envío de archivos. Mejorá tu plan para continuar.',
                'attachments.recipientFreeBlocked.title': 'Límite del plan',
                'attachments.recipientFreeBlocked.sender': 'El usuario tiene plan Free y no puede recibir archivos adjuntos.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} intentó enviarte un archivo adjunto, pero tu plan Free no permite recibir adjuntos. Te recomendamos pasar a un plan superior para recibir archivos.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Mejorar plan',
                'message.audioDeprecated.title': 'Mensaje de voz no compatible',
                'message.audioDeprecated.message': 'Este mensaje de voz ya no es compatible con ArChat®. Por favor, envía un mensaje escrito.',
                'camera.title': 'Cámara',
                'camera.close': 'Cerrar',
                'camera.switch': 'Cambiar cámara',
                'camera.capture': 'Tomar Foto',
                'camera.loading': 'Iniciando cámara...',
                'camera.retry': 'Reintentar',
                'camera.error.access': 'No se pudo acceder a la cámara. Verifica los permisos.',
                'camera.error.permission': 'Permisos de cámara denegados. Por favor, permite el acceso a la cámara en la configuración del navegador.',
                'camera.error.notFound': 'No se encontró ninguna cámara disponible.',
                'camera.error.busy': 'La cámara está siendo usada por otra aplicación.',
                'camera.error.constraint': 'Las restricciones de la cámara no se pueden satisfacer.',
                'profile.photo.take': 'Tomar foto',
                'profile.photo.gallery': 'Elegir de galería',
                'profile.photo.select': 'Seleccionar foto',
                'profile.photo.select.gallery': 'Elegir de galería',
                'profile.photo.uploading': 'Subiendo imagen...',
                'profile.photo.upload.success': 'Foto de perfil actualizada correctamente',
                'profile.photo.upload.success.title': 'Foto Actualizada',
                'profile.photo.upload.error': 'Error al subir la foto de perfil. Por favor, intenta nuevamente.',
                'profile.photo.upload.error.title': 'Error al Subir Foto',
                'avatar.errors.too_large': 'La imagen es demasiado grande. Tamaño máximo: 2 MB.',
                'avatar.preview.title': 'Vista previa del avatar',
                'profile.avatar.error_title': 'No se pudo actualizar el avatar',
                'profile.avatar.error.title': 'No se pudo actualizar el avatar',
                'profile.avatar.error.size': 'La imagen supera el tamaño permitido. El máximo es 2 MB.',
                'profile.avatar.tooLarge.title': 'Imagen demasiado grande',
                'profile.avatar.tooLarge.message': 'La foto supera el tamaño permitido. El máximo es 2 MB.',
                'profile.avatar.uploadError.title': 'No se pudo actualizar el avatar',
                'profile.avatar.uploadError.message': 'Ocurrió un problema al subir la imagen. Intenta nuevamente.',
                'profile.saveSuccess.title': 'Perfil actualizado',
                'profile.saveSuccess.message': 'Tus cambios se guardaron correctamente.',
                'profile.avatar.file_too_large': 'La imagen supera el tamaño máximo permitido (2 MB).',
                'profile.avatar.file_too_large_hint': 'Elegí una imagen más liviana o reducí su tamaño e intentá nuevamente.',
                'profile.photo.take.front': 'Cámara frontal',
                'profile.photo.take.back': 'Cámara trasera',
                'profile.photo.take.webcam': 'Cámara web',
                'profile.photo.camera.front': 'Cámara frontal',
                'profile.photo.camera.back': 'Cámara trasera',
                'profile.photo.camera.web': 'Cámara web',
                'profile.photo.close': 'Cerrar',
                'profile.photo.capture': 'Capturar',
                'profile.country.help': 'La zona horaria se asignará automáticamente según el país seleccionado',
                'profile.lastname.placeholder': 'Tu apellido (opcional)',
                'profile.name.placeholder': 'Tu nombre real (opcional)',
                'profile.biography.placeholder': 'Cuéntanos sobre ti...',
                'user.default': 'Usuario',
                'logout.title': 'Confirmar',
                'logout.confirm': '¿Estás seguro de que deseas cerrar sesión?',
                'block.toggle_error': 'No se pudo bloquear o desbloquear.',
                'contacts.title': 'Contactos',
                'contacts.search': 'Buscar contacto',
                'contacts.search.placeholder': 'Buscar por nombre de usuario, nombre, apellido, país o idioma...',
                'contacts.sort': 'Ordenar',
                'contacts.sortByName': 'Por nombre',
                'contacts.sortByStatus': 'Por estado',
                'contacts.sortByRecent': 'Más recientes',
                'contacts.filter': 'Filtrar',
                'contacts.filterAll': 'Todos',
                'contacts.filterAvailable': 'Disponibles',
                'contacts.filterInvited': 'Invitados',
                'contacts.filterBlocked': 'Bloqueados',
                'contacts.pending_invitations': 'Invitaciones pendientes',
                'contacts.status.invitation_sent': 'Invitación enviada',
                'contacts.viewContactInfo': 'Ver datos del contacto',
                'contacts.contactInfoTitle': 'Datos del contacto',
                'contacts.phone': 'Teléfono',
                'contacts.bio': 'Biografía',
                'contacts.notProvided': 'No informado',
                'contacts.empty.title': 'Todavía no tenés contactos',
                'contacts.empty.message': 'Invitá o creá uno para comenzar.',
                'contacts.empty.invite_button': 'Invitar un contacto',
                'contacts.controls.search_placeholder': 'Buscar contacto...',
                'contacts.controls.search_label': 'Buscar contacto',
                'contacts.controls.sort_label': 'Ordenar por',
                'contacts.controls.sort.name': 'Nombre',
                'contacts.controls.sort.status': 'Estado',
                'contacts.controls.sort.recent': 'Reciente',
                'contacts.controls.sort.manual': 'Manual',
                'contacts.controls.sort.manual_drag_hint': 'Arrastrar para reordenar',
                'contacts.controls.filter_label': 'Estado',
                'contacts.controls.filter.all': 'Todos',
                'contacts.controls.filter.available': 'Disponibles',
                'contacts.controls.filter.invited': 'Invitados',
                'contacts.controls.filter.blocked': 'Bloqueados',
                'contacts.controls.filter.favorites': 'Favoritos',
                'contacts.nick': 'Nombre de usuario',
                'contacts.name': 'Nombre',
                'contacts.lastname': 'Apellido',
                'contacts.country': 'País',
                'contacts.language': 'Idioma',
                'contacts.status': 'Estado',
                'contacts.mode': 'Modo',
                'contacts.sent': 'Enviada',
                'contacts.actions': 'Acciones',
                'contacts.pending': 'Pendiente',
                'contacts.available': 'Disponible',
                'contacts.invited_registered': 'Invitado - Registrado',
                'status.available': 'Disponible',
                'status.busy': 'Ocupado',
                'status.in_call': 'En llamada',
                'status.away': 'Ausente',
                'status.offline': 'Desconectado',
                'status.custom': 'Mensaje personalizado',
                'status.set_title': 'Estado de disponibilidad',
                'status.set_button': 'Cambiar estado',
                'status.placeholder': 'Mensaje opcional (ej: En reunión)',
                'contacts.status.pending_registration': 'Pendiente de registro',
                'contacts.status.registered': 'Invitado - Registrado',
                'contacts.status.ready_to_chat': 'Listo para chatear',
                'contacts.status.active_conversation': 'Conversación activa',
                'contact.favorite.add': 'Añadir a favoritos',
                'contact.favorite.remove': 'Quitar de favoritos',
                'contact.block.block': 'Bloquear',
                'contact.block.unblock': 'Desbloquear',
                'contacts.invitation.pending.title': 'Invitación Pendiente',
                'contacts.invitation.pending.message': 'Esta invitación está pendiente de registro. El contacto recibirá un email para completar su alta. Una vez registrado, podrás chatear con él.',
                'contacts.error.no_registered': 'El contacto aún no está registrado. Espera a que complete su registro.',
                'contact.edit.title': 'Editar Contacto',
                'contact.edit.alias.label': 'Alias personalizado',
                'contact.edit.alias.placeholder': 'Ej: Juan del trabajo',
                'contact.edit.alias.help': 'Este nombre aparecerá en lugar del nombre real',
                'contact.edit.nota.label': 'Nota personal',
                'contact.edit.nota.placeholder': 'Agrega una nota sobre este contacto...',
                'contact.edit.nota.help': 'Notas privadas solo visibles para ti',
                'contact.edit.error.noUser': 'Error: Usuario no identificado',
                'contact.edit.error.noContactId': 'Error: No se pudo identificar el contacto',
                'contact.edit.error.save': 'Error al guardar',
                'contact.limit.title': 'Límite de contactos alcanzado',
                'contact.limit.message': 'El plan FREE permite hasta 2 contactos por usuario. Podés pasar a FOUNDATION o PRO para más capacidad cuando el cobro esté habilitado.',
                'conversation.backToContacts': 'Volver a contactos',
                'conversation.notFound': 'No se encontró la conversación',
                'help.title': 'Ayuda de ArChat®',
                'help.howWorks.title': '👥 Cómo funciona ArChat® (flujo real)',
                'help.howWorks.step1.title': '1️⃣ Registro',
                'help.howWorks.step1.point1': 'Inicia sesión con tu nick y contraseña.',
                'help.howWorks.step1.point2': 'Si no tienes cuenta, se crea automáticamente.',
                'help.howWorks.step1.point3': 'Aceptas los Términos y Condiciones en tu idioma.',
                'help.howWorks.step1.point4': 'Confirmas tu cuenta por email.',
                'help.howWorks.step2.title': '2️⃣ Invitaciones privadas',
                'help.howWorks.step2.point1': 'Invita contactos por email desde tu perfil.',
                'help.howWorks.step2.point2': 'Define el idioma y el modo de conversación antes de iniciar.',
                'help.howWorks.step2.point3': 'El contacto recibe una invitación privada.',
                'help.howWorks.step2.point4': 'Puedes ver si está: Pendiente, Registrado, Listo para conversar',
                'help.howWorks.step2.point5': 'Los contactos no se buscan, se invitan.',
                'help.howWorks.step2.point6': 'Los contactos no se buscan, se invitan.',
                'help.howWorks.step3.title': '3️⃣ Contactos y conversaciones',
                'help.howWorks.step3.point1': 'Tus contactos aparecen automáticamente cuando:',
                'help.howWorks.step3.point2': 'aceptan una invitación',
                'help.howWorks.step3.point3': 'o existe una conversación',
                'help.howWorks.step3.point4': 'Puedes:',
                'help.howWorks.step3.point5': 'marcarlos como favoritos ⭐',
                'help.howWorks.step3.point6': 'asignarles alias personalizados',
                'help.howWorks.step3.point7': 'agregar notas privadas',
                'help.howWorks.step3.point8': 'bloquearlos o gestionarlos',
                'help.howWorks.step3.point9': 'No hay agenda pública ni usuarios visibles sin consentimiento.',
                'help.howWorks.step4.title': '4️⃣ Mensajería con traducción',
                'help.howWorks.step4.point1': 'Escribe siempre en tu idioma.',
                'help.howWorks.step4.point2': 'El sistema traduce automáticamente el mensaje.',
                'help.howWorks.step4.point3': 'El receptor lo recibe en su idioma.',
                'help.howWorks.step4.point4': 'Puedes ver la traducción aplicada.',
                'help.howWorks.step4.point5': 'Si falla una traducción, se reintenta automáticamente.',
                'help.howWorks.step4.point6': 'ArChat® prioriza claridad y sentido, no solo velocidad.',
                'help.privacy.title': '🔒 Privacidad y control',
                'help.privacy.point1': 'Tu perfil es privado por defecto.',
                'help.privacy.point2': 'Solo quienes invites pueden verte o escribirte.',
                'help.privacy.point3': 'La visibilidad pública es opcional y desactivada por defecto.',
                'help.privacy.point4': 'Seguridad activa con:',
                'help.privacy.point5': 'CAPTCHA',
                'help.privacy.point6': 'rate limiting',
                'help.privacy.point7': 'fingerprint',
                'help.privacy.point8': 'verificación por email',
                'help.privacy.point9': 'Tus conversaciones no son públicas ni indexadas.',
                'help.files.title': '📎 Archivos y exportación',
                'help.files.point1': 'Adjunta imágenes, videos y documentos PDF.',
                'help.files.point2': 'Captura fotos con cámara frontal, trasera o webcam.',
                'help.files.point3': 'Las imágenes se comprimen automáticamente.',
                'help.files.point4': 'Vista previa antes de enviar.',
                'help.files.point5': 'Barra de progreso durante la carga.',
                'help.files.point6': 'Exporta conversaciones completas a:',
                'help.files.point7': 'PDF',
                'help.files.point8': 'HTML',
                'help.files.point9': 'Incluye mensajes, imágenes y archivos.',
                'help.files.point10': 'Tus datos son tuyos.',
                'help.experience.title': '🎨 Experiencia de uso',
                'help.experience.point1': 'Estados de presencia y estados personalizados con emoji.',
                'help.experience.point2': 'Emojis OpenMoji integrados.',
                'help.experience.point3': 'Indicadores de lectura y escritura.',
                'help.experience.point4': 'Vista móvil optimizada igual a escritorio.',
                'help.experience.point5': 'Aplicación PWA instalable.',
                'help.experience.point6': 'Dos temas: Argentina (celeste/blanco/dorado) y Oscuro (púrpura profundo).',
                'help.experience.point7': 'Edición de perfil sin refrescos.',
                'help.experience.point8': 'Selector de país con zona horaria automática.',
                'help.experience.point9': 'Acceso rápido con favoritos, búsqueda y filtros.',
                'help.languages.title': '🌍 Idiomas',
                'help.languages.point1': 'Soporte para {count} idiomas.',
                'help.languages.point2': 'Selector visual con banderas.',
                'help.languages.point3': 'Interfaz, T&C y emails adaptados al idioma elegido.',
                'help.languages.point4': 'Traducción automática bidireccional entre usuarios.',
                'help.tipsNew.title': '💡 Consejos para aprovechar ArChat®',
                'help.tipsNew.point1': 'Invita solo a las personas con las que realmente quieres comunicarte.',
                'help.tipsNew.point2': 'Usa alias y notas privadas para organizar contactos.',
                'help.tipsNew.point3': 'Marca favoritos para acceder rápido.',
                'help.tipsNew.point4': 'Revisa la traducción antes de enviar mensajes importantes.',
                'help.tipsNew.point5': 'Exporta conversaciones relevantes para respaldo o trabajo.',
                'help.tipsNew.point6': 'Usa ArChat® cuando la claridad escrita sea clave.',
                'help.whySubscribe.title': '🚀 Por qué suscribirte a ArChat®',
                'help.whySubscribe.point1': 'ArChat® no está pensado para chatear con cualquiera,',
                'help.whySubscribe.point2': 'sino para comunicarte mejor con quien importa.',
                'help.whySubscribe.point3': 'Si necesitas:',
                'help.whySubscribe.point4': 'claridad entre idiomas',
                'help.whySubscribe.point5': 'privacidad real',
                'help.whySubscribe.point6': 'control de contactos',
                'help.whySubscribe.point7': 'exportación de conversaciones',
                'help.whySubscribe.point8': 'una experiencia profesional y sin ruido',
                'help.whySubscribe.point9': 'ArChat® está diseñado para eso.',
                'help.how.step1.description': 'Usa tu nick y contraseña para acceder. Si no tienes cuenta, se crea automáticamente.',
                'help.how.step2.title': 'Invita a tu contacto',
                'help.how.step2.description': 'Invita por email desde tu perfil y define idioma y modo de conversación.',
                'help.how.step3.title': 'Escribe en tu idioma',
                'help.how.step3.description': 'Escribe en tu idioma preferido y ArChat® traduce automáticamente el mensaje.',
                'help.how.step4.title': 'El receptor lo recibe traducido',
                'help.how.step4.description': 'La otra persona recibe el mensaje traducido a su idioma con contexto y claridad.',
                'help.features.title': 'Características principales',
                'help.features.translation': '🌐 Traducción automática e instantánea entre idiomas',
                'help.features.status': '💬 Estados de presencia (En línea, Inactivo, No molestar, etc.)',
                'help.features.statusCustom': '💬 Estados personalizados con emoji y mensaje personalizado',
                'help.features.contacts': '👥 Lista completa de contactos con favoritos anclados (top) y bloqueos gestionables desde el modal de Usuarios',
                'help.features.contactsMobile': '📱 Vista móvil optimizada con estado y apariencia en la barra superior (igual a PC)',
                'help.features.contactsFilter': '👁️ Botón para mostrar/ocultar contactos no favoritos - reduce la lista a solo tus favoritos',
                'help.features.contactAlias': '✏️ Alias personalizado y notas privadas para cada contacto - haz clic en el nombre del contacto en la conversación',
                'help.features.themes': '🎨 Dos temas disponibles: Argentina (celeste/blanco/dorado) y Oscuro (púrpura profundo)',
                'help.features.messages': '📨 Mensajería en tiempo real con indicadores de lectura, emojis OpenMoji inline y tipado visible',
                'help.features.attachments': '📎 Adjuntar archivos compatibles con comunicación escrita: imágenes, videos y documentos PDF',
                'help.features.camera': '📸 Captura de fotos con cámara frontal, trasera o webcam',
                'help.features.gallery': '🖼️ Selección de archivos desde galería',
                'help.features.compression': '🗜️ Compresión automática de imágenes y generación de thumbnails',
                'help.features.progress': '📊 Barra de progreso durante la carga de archivos',
                'help.features.delete': '🗑️ Eliminación de mensajes propios',
                'help.features.scroll': '⬇️ Scroll automático al último mensaje al abrir conversación',
                'help.features.profile': '👤 Perfil personalizable con avatar, biografía y preferencias',
                'help.features.profileEdit': '✏️ Edición de perfil sin interrupciones (no se refresca mientras editas)',
                'help.features.countries': '🌍 Lista completa de 195+ países con selección automática de zona horaria',
                'help.features.registration': '📧 Registro con Términos y Condiciones obligatorios antes de crear cuenta y confirmación por email',
                'help.features.multilanguage': '🗣️ Soporte para {count} idiomas con banderas; T&C y emails traducidos al idioma elegido',
                'help.features.pwa': '📲 Aplicación PWA instalable en dispositivos móviles y escritorio',
                'help.features.sync': '🔄 Sincronización automática de mensajes cada 5 segundos',
                'help.features.deleteSync': '🗑️ Sincronización automática de mensajes eliminados entre dispositivos',
                'help.features.notifications': '🔔 Notificaciones de sonido para nuevos mensajes recibidos',
                'help.features.retranslation': '🔄 Re-traducción automática de mensajes si falla la primera vez',
                'help.features.preview': '👁️ Vista previa de archivos antes de enviar',
                'help.features.security': '🔒 Sistema de seguridad con CAPTCHA, fingerprint, rate limiting y flujo T&C obligatorio',
                'help.features.passwordRecovery': '🔑 Recuperación de contraseña por email',
                'help.features.emailConfirmation': '📧 Confirmación de cuenta por email con enlace de activación',
                'help.features.invitations': '📧 Invitaciones privadas por email - Invita contactos externos con idioma y contexto definidos',
                'help.features.invitationsManagement': '📋 Gestión completa de invitaciones - Lista, reenvía o cancela invitaciones pendientes desde el menú',
                'help.features.contactStatus': '🏷️ Estados de contacto visibles - Ve el estado de cada contacto (pendiente, registrado, listo para chatear)',
                'help.features.favorites': '⭐ Sistema de favoritos - Marca contactos como favoritos para acceder rápidamente a ellos',
                'help.features.profilePhoto': '📸 Subida mejorada de foto de perfil - Selecciona imágenes desde galería con vista previa inmediata',
                'help.features.translationSender': '👁️ Visualización de traducciones para el emisor - Ve cómo se tradujo tu mensaje al idioma del receptor',
                'help.features.unifiedContacts': '🔗 Modelo unificado de contactos - Los contactos se derivan de invitaciones y conversaciones existentes',
                'help.features.privacy': '🔒 Modo privado por defecto - Tu perfil es privado y solo accesible mediante invitación directa',
                'help.features.export': '💾 Exportación de conversaciones - Exporta conversaciones completas a PDF o HTML con imágenes y archivos',
                'help.tips.title': 'Consejos útiles',
                'help.tips.language': '✅ Configura tu idioma con el selector de {count} banderas; T&C y emails se muestran en ese idioma',
                'help.tips.status': '✅ Actualiza tu estado de presencia para que otros sepan tu disponibilidad',
                'help.tips.statusCustom': '✅ Crea estados personalizados con emoji y mensaje para expresar tu estado actual',
                'help.tips.search': '✅ Marca favoritos (estrella) y bloquea usuarios desde el modal "Usuarios"',
                'help.tips.contactsFilter': '✅ Usa el botón del ojo (👁️) en la barra superior para mostrar u ocultar contactos que no son favoritos',
                'help.tips.contactAlias': '✅ Haz clic en el nombre del contacto en la conversación para agregar un alias personalizado y notas privadas',
                'help.tips.avatar': '✅ Haz clic en el avatar de un contacto para ver su imagen en grande',
                'help.tips.messages': '✅ El icono ArChat® parpadea cuando tienes mensajes no leídos; inserta emojis con el selector OpenMoji',
                'help.tips.attachments': '✅ Adjunta imágenes, videos o PDFs usando el botón de clip (📎); compatible con comunicación escrita',
                'help.tips.camera': '✅ Usa la cámara para capturar fotos directamente desde la app',
                'help.tips.compression': '✅ Las imágenes se comprimen automáticamente para ahorrar espacio',
                'help.tips.delete': '✅ Puedes eliminar tus propios mensajes haciendo clic en el botón de eliminar',
                'help.tips.profile': '✅ Edita tu perfil sin refrescos y cambia entre Argentina / Oscuro (tema claro u oscuro).',
                'help.tips.themes': '✅ Cambia el tema desde Configuración > Apariencia: Argentina (celeste) u Oscuro (púrpura profundo)',
                'help.tips.country': '✅ Selecciona tu país en el perfil para que la zona horaria se configure automáticamente',
                'help.message_time_context.title': 'Contexto temporal de mensajes',
                'help.message_time_context.description': 'Cada mensaje puede guardar la hora local del emisor, su zona horaria y su país en el momento del envío. Así podés ver desde dónde y a qué hora envió el otro usuario.',
                'help.message_time_context.point1': 'En plan FREE se muestra solo la hora en tu zona horaria (receptor).',
                'help.message_time_context.point2': 'En plan PRO se muestra además la hora local del emisor, su país y zona horaria.',
                'help.message_time_context.point3': 'El contexto queda guardado de forma histórica en cada mensaje.',
                'help.message_time_context.point4': 'Funciones avanzadas de auditoría están disponibles en planes superiores.',
                'help.tips.registration': '✅ Antes de registrar, acepta los T&C en tu idioma; luego verifica tu email para activar la cuenta',
                'help.tips.writing': '✅ Escribe mensajes claros: ArChat® traduce el significado del texto escrito, manteniendo contexto y claridad',
                'help.tips.install': '✅ Instala ArChat® como aplicación PWA en tu dispositivo para acceso rápido desde el escritorio',
                'help.tips.sync': '✅ Los mensajes se sincronizan automáticamente cada 5 segundos - no necesitas refrescar',
                'help.tips.deleteSync': '✅ Si eliminas un mensaje, se eliminará automáticamente en todos los dispositivos del receptor',
                'help.tips.notifications': '✅ Escucharás un sonido cuando recibas un nuevo mensaje de otro usuario',
                'help.tips.retranslation': '✅ Si un mensaje no se tradujo correctamente, el sistema intentará re-traducirlo automáticamente',
                'help.tips.preview': '✅ Revisa la vista previa de archivos antes de enviarlos para asegurarte de que es el correcto',
                'help.tips.passwordRecovery': '✅ Si olvidaste tu contraseña, usa el enlace "¿Olvidaste tu contraseña?" en el login',
                'help.tips.emailConfirmation': '✅ Revisa tu email después de registrarte y haz clic en el enlace de confirmación',
                'help.tips.languageChange': '✅ Cambia tu idioma desde el selector de banderas: T&C, emails y UI se actualizan al instante',
                'help.tips.inputFixed': '✅ En PC, la barra de escritura queda fija al pie de la pantalla para mayor comodidad',
                'help.tips.invitations': '✅ Invita contactos por email desde tu perfil - Define el idioma y modo de conversación desde el inicio',
                'help.tips.invitationsManagement': '✅ Gestiona tus invitaciones desde el menú "Invitaciones Enviadas" - Reenvía emails o cancela invitaciones pendientes',
                'help.tips.contactStatus': '✅ Observa el estado de cada contacto en la lista - Pendiente (naranja), Registrado (verde) o Conversación activa (azul)',
                'help.tips.favorites': '✅ Marca contactos como favoritos con la estrella ⭐ - Los favoritos aparecen primero en tu lista',
                'help.tips.profilePhoto': '✅ Sube tu foto de perfil desde "Elegir de galería" - Verás una vista previa antes de guardar',
                'help.tips.translationSender': '✅ Al enviar un mensaje, expande el panel de traducción para ver cómo se tradujo al idioma del receptor',
                'help.tips.unifiedContacts': '✅ Tus contactos se muestran automáticamente cuando aceptan invitaciones o tienes conversaciones con ellos',
                'help.tips.privacy': '✅ Tu perfil es privado por defecto - Activa la visibilidad pública en Perfil > Privacidad si deseas que otros te encuentren',
                'help.tips.export': '✅ Exporta conversaciones completas usando el botón ⬇️ en el encabezado - Elige PDF o HTML con todas las imágenes',
                'help.support.title': 'Soporte',
                'help.support.description': 'Si tienes problemas o preguntas, contacta al administrador del sistema o revisa la documentación técnica disponible.',
                'help.about.title': 'Acerca de',
                'help.about.developer': 'Desarrollado por:',
                'help.about.location': 'MDQ - ARGENTINA',
                'help.about.linkedin': 'Ver perfil en LinkedIn',
                'presence.title': 'Estado de Presencia',
                'presence.currentStatus': 'Estado actual:',
                'presence.changeStatus': 'Cambiar estado',
                'presence.status.online': 'En línea',
                'presence.status.online.title': 'En línea - Visible para todos',
                'presence.status.online.description': 'En línea: Visible para todos los contactos',
                'presence.status.idle': 'Inactivo',
                'presence.status.idle.title': 'Inactivo - Indica ausencia temporal',
                'presence.status.idle.description': 'Inactivo: Indica que no estás disponible temporalmente',
                'presence.status.dnd': 'No molestar',
                'presence.status.dnd.title': 'No molestar - Indica que prefieres no ser interrumpido',
                'presence.status.dnd.description': 'No molestar: Señal visible de que prefieres no ser interrumpido',
                'presence.status.busy': 'Ocupado',
                'presence.status.busy.title': 'Ocupado - No disponible',
                'presence.status.busy.description': 'Ocupado: No disponible',
                'presence.status.offline': 'Offline',
                'presence.status.offline.title': 'Desconectado - Aparecer offline',
                'presence.status.offline.description': 'Offline: Aparecer desconectado',
                'presence.status.custom': 'Personalizado',
                'presence.status.custom.title': 'Personalizado - Estado único con emoji',
                'presence.status.custom.description': 'Personalizado: Estado único con emoji y expiración opcional',
                'presence.custom.title': 'Estado Personalizado',
                'presence.custom.status': 'Estado personalizado',
                'presence.custom.placeholder': 'Ej: Tomando unos mates ☕',
                'presence.custom.emoji': 'Emoji (opcional)',
                'presence.custom.emojiHelp': 'Selecciona un emoji o escribe uno',
                'presence.custom.temporary': 'Estado temporal (expira automáticamente)',
                'presence.custom.expiration': 'Fecha de expiración',
                'presence.custom.expirationHelp': 'El estado volverá a "En línea" cuando expire',
                'presence.custom.suggestions': 'Sugerencias argentinas',
                'presence.custom.preview': 'Vista previa',
                'presence.custom.save': 'Guardar Estado',
                'presence.custom.required': 'El estado personalizado es requerido',
                'presence.custom.maxLength': 'Máximo 64 caracteres',
                'presence.custom.expirationRequired': 'Debes seleccionar una fecha de expiración',
                'presence.custom.expirationFuture': 'La fecha de expiración debe ser futura',
                'presence.custom.selectEmoji': 'Seleccionar emoji',
                'presence.custom.suggestion.coffee': 'Tomando unos mates ☕',
                'presence.custom.suggestion.soccer': 'En la cancha ⚽',
                'presence.custom.suggestion.working': 'Laburando como loco 💪',
                'presence.custom.suggestion.lunch': 'Almorzando 🍽️',
                'presence.custom.suggestion.family': 'Almuerzo familiar 👨‍👩‍👧‍👦',
                'presence.custom.suggestion.studying': 'Estudiando 📚',
                'presence.custom.suggestion.travel': 'De viaje ✈️',
                'presence.custom.suggestion.meeting': 'En reunión 💼',
                'presence.custom.suggestion.resting': 'Descansando 😴',
                'presence.custom.suggestion.gaming': 'Jugando videojuegos 🎮',
                'presence.custom.suggestion.reading': 'Leyendo 📖',
                'presence.custom.suggestion.offlineSoon': 'Vuelvo enseguida ⏳',
                'invitation.title': 'Invitar Contacto por Email',
                'invitation.modal.title': 'Enviar Invitación',
                'invitation.modal.description': 'Invita a alguien a chatear contigo en ArChat®. Se le enviará un email con un enlace para aceptar la invitación.',
                'invitation.email.label': 'Email del invitado',
                'invitation.email.placeholder': 'ejemplo@email.com',
                'invitation.email.required': 'El email es obligatorio',
                'invitation.email.invalid': 'Por favor, ingresa un email válido',
                'invitation.language.label': 'Idioma preferido del invitado',
                'invitation.language.help': 'El email se enviará en este idioma',
                'invitation.mode.label': 'Modo de conversación',
                'invitation.mode.profesional': 'Profesional',
                'invitation.mode.profesional.description': 'Conversación formal y profesional',
                'invitation.mode.tecnico': 'Técnico',
                'invitation.mode.tecnico.description': 'Conversación técnica y especializada',
                'invitation.mode.casual': 'Casual',
                'invitation.mode.casual.description': 'Conversación informal y amigable',
                'invitation.message.label': 'Mensaje personal (opcional)',
                'invitation.message.placeholder': 'Escribe un mensaje personal para el invitado...',
                'invitation.send': 'Enviar Invitación',
                'invitation.sending': 'Enviando...',
                'invitation.success': 'Invitación enviada correctamente',
                'invitation.success.title': 'Invitación Enviada',
                'invitation.success.message': 'Invitación enviada correctamente.\n\nEl contacto recibirá un email con un enlace para aceptar la invitación. Una vez aceptada, podrás comenzar a chatear con él.',
                'invitation.error': 'Error al enviar la invitación',
                'invitation.error.self': 'No puedes invitarte a ti mismo',
                'invitation.error.duplicate': 'Ya existe una invitación pendiente para este email',
                'invitation.list.title': 'Invitaciones Enviadas',
                'invitation.top.title': 'Top Constructores de Red',
                'invitation.top.invitesSuffix': 'invitaciones',
                'invitation.safe.phase_notice': 'Fase segura activa: beneficios pendientes de activación comercial (sin impacto real en límites).',
                'invitation.safe.generate_code': 'Generar link/código',
                'invitation.safe.refresh_top3': 'Actualizar Top 3',
                'invitation.safe.top_loading': 'Cargando top invitadores...',
                'invitation.safe.top_empty': 'Aún no hay invitadores destacados.',
                'invitation.safe.hide_full_ranking': 'Ocultar ranking completo',
                'invitation.safe.view_full_ranking': 'Ver ranking completo',
                'invitation.safe.hide_metrics_dashboard': 'Ocultar dashboard de métricas',
                'invitation.safe.view_metrics_dashboard': 'Ver dashboard de métricas',
                'invitation.safe.prepared_link': 'Link preparado',
                'invitation.safe.email_placeholder': 'email@dominio.com',
                'invitation.safe.register_pending': 'Registrar invitación pendiente',
                'invitation.safe.status_summary': 'Resumen de estados',
                'invitation.safe.summary.pending': 'Pendientes',
                'invitation.safe.summary.registered': 'Registradas',
                'invitation.safe.summary.active': 'Activas',
                'invitation.safe.summary.validated': 'Validadas',
                'invitation.safe.summary.rejected': 'Rechazadas',
                'invitation.safe.sent_invitations': 'Invitaciones emitidas',
                'invitation.safe.table.id': 'ID',
                'invitation.safe.table.invited_email': 'Email invitado',
                'invitation.safe.table.code': 'Código',
                'invitation.safe.table.status': 'Estado',
                'invitation.safe.table.created': 'Creada',
                'invitation.safe.empty_sent': 'Sin invitaciones emitidas todavía.',
                'invitation.safe.simulated_rewards': 'Recompensas simuladas obtenidas',
                'invitation.safe.empty_rewards': 'Sin recompensas simuladas por ahora.',
                'invitation.safe.error.load_status': 'No se pudo cargar el estado de invitaciones.',
                'invitation.safe.error.generate_code': 'No se pudo generar el código.',
                'invitation.safe.error.invalid_email': 'Ingresá un email válido para registrar invitación.',
                'invitation.safe.error.register_pending': 'No se pudo registrar la invitación pendiente.',
                'invitation.safe.success.code_generated': 'Código generado correctamente.',
                'invitation.safe.success.pending_registered': 'Invitación pendiente registrada en modo seguro.',
                'invitation.ranking.position': 'Posición',
                'invitation.ranking.user': 'Usuario',
                'invitation.ranking.validatedInvites': 'Invitaciones validadas',
                'invitation.ranking.empty': 'No hay invitaciones validadas para mostrar.',
                'invitation.ranking.loading': 'Cargando ranking...',
                'invitation.ranking.loadError': 'No se pudo cargar el ranking.',
                'invitation.list.empty': 'No has enviado ninguna invitación',
                'invitation.list.email': 'Email',
                'invitation.list.language': 'Idioma',
                'invitation.list.mode': 'Modo',
                'invitation.list.status': 'Estado',
                'invitation.list.created': 'Enviada',
                'invitation.list.expires': 'Expira',
                'invitation.list.actions': 'Acciones',
                'table.email': 'Email',
                'table.language': 'Idioma',
                'table.mode': 'Modo',
                'table.status': 'Estado',
                'table.sent': 'Enviada',
                'table.actions': 'Acciones',
                'invitation.status.pending': 'Pendiente',
                'invitation.status.accepted': 'Aceptada',
                'invitation.status.expired': 'Expirada',
                'invitation.status.cancelled': 'Cancelada',
                'invitation.status.deleted': 'Eliminada',
                'invitation.deleted.tooltip': 'Esta invitación fue eliminada',
                'invitation.status.rejected': 'Rechazada',
                'invitation.status.bounced': 'Rebotada',
                'invitation.status.unknown': 'Estado desconocido',
                'invitation.copy.link': 'Copiar enlace',
                'invitation.copy.success': 'Enlace copiado al portapapeles',
                'invitation.cancel': 'Cancelar',
                'invitation.cancel.confirm': '¿Estás seguro de cancelar esta invitación?',
                'invitation.cancel.success': 'Invitación cancelada correctamente',
                'invitation.cancel.title': 'Confirmar Cancelación',
                'invitation.resend': 'Reenviar email',
                'invitation.resend.title': 'Reenviar Invitación',
                'invitation.resend.success': 'Email de invitación reenviado correctamente',
                'invitation.resend.error': 'Error al reenviar el email de invitación',
                'invitation.accept.title': 'Aceptar Invitación',
                'invitation.accept.description': 'Has sido invitado a chatear en ArChat®',
                'invitation.accept.inviter': 'Invitado por',
                'invitation.accept.message': 'Mensaje personal',
                'invitation.accept.login': 'Iniciar Sesión',
                'invitation.accept.register': 'Registrarse',
                'invitation.accept.error.invalid': 'Token de invitación inválido',
                'invitation.accept.error.expired': 'Esta invitación ha expirado',
                'invitation.accept.error.accepted': 'Esta invitación ya fue aceptada',
                'invitation.accept.error.cancelled': 'Esta invitación fue cancelada',
                'invitation.accept.error.email_mismatch': 'El email de tu cuenta no coincide con el de la invitación',
                'invitation.accept.success': 'Invitación aceptada. Redirigiendo al chat...',
                'invitations.sent.title': 'Invitaciones enviadas',
                'invitations.sent.empty': 'No hay invitaciones pendientes',
                'invitations.pending.title': 'Invitaciones pendientes',
                'invitations.columns.email': 'Email',
                'invitations.columns.language': 'Idioma',
                'invitations.columns.mode': 'Modo',
                'invitations.columns.status': 'Estado',
                'invitations.columns.sentAt': 'Enviada',
                'invitations.columns.actions': 'Acciones',
                'invitations.status.pending': 'Pendiente',
                'invitations.status.accepted': 'Aceptada',
                'invitations.status.cancelled': 'Cancelada',
                'invitations.status.expired': 'Expirada',
                'invitations.actions.cancel': 'Cancelar',
                'invitations.actions.copy': 'Copiar enlace',
                'invitations.actions.resend': 'Reenviar email',
                'invitations.waitBeforeResend': 'No puedes reenviar la invitación todavía. Debes esperar 10 minutos entre cada envío para evitar spam al usuario invitado.',
                'invitations.captchaQuestion': '¿Cuánto es %1 + %2?',
                'invitations.resendSuccess': 'La invitación fue reenviada correctamente.',
                'invitations.dailyLimit': 'Has alcanzado el máximo de reenvíos permitidos hoy.',
                'invitations.invalidEmail': 'El servidor de correo informó que esta dirección es inválida.',
                'profile.privacy.title': 'Privacidad',
                'profile.privacy.public_visibility': 'Hacer mi perfil visible públicamente',
                'profile.privacy.public_warning': 'Esto permite que cualquier usuario de ArChat® pueda encontrarte e iniciar conversación.',
                'profile.privacy.private_info': 'Tu perfil es privado. Solo los usuarios a los que invites o que te inviten podrán chatear contigo.',
                'profile.privacy.private_default': 'Por defecto, tu perfil es privado para mayor seguridad.',
                'contacts.empty': 'No hay contactos',
                'contacts.empty.private.message': 'Tu perfil es privado. Invita contactos para comenzar a chatear.',
                'contacts.empty.private.invite_button': 'Invitar un contacto',
                'contacts.unread.badge': 'Mensajes sin leer',
                'contacts.search.no_results': 'No se encontraron contactos',
                'contacts.search.clear': 'Mostrar todos',
                'common.close': 'Cerrar',
                'common.cancel': 'Cancelar',
                'common.confirm': 'Confirmar',
                'common.save': 'Guardar',
                'common.saving': 'Guardando...',
                'buttons.accept': 'Aceptar',
                'buttons.cancel': 'Cancelar',
                'buttons.save': 'Guardar',
                'buttons.edit': 'Editar',
                'buttons.retry': 'Reintentar',
                'buttons.confirm': 'Confirmar',
                'buttons.yes': 'Sí',
                'buttons.no': 'No',
                'buttons.send': 'Enviar',
                'buttons.close': 'Cerrar',
                'buttons.continue': 'Continuar',
                'buttons.delete': 'Eliminar',
                'buttons.logout': 'Salir',
                'buttons.back': 'Volver',
                'buttons.update': 'Actualizar',
                'buttons.upload': 'Subir',
                'buttons.select': 'Seleccionar',
                'achievement.unlocked': 'Logro desbloqueado',
                'achievement.continue': 'Continuar',
                'contact.edit.info.personalized': 'Estos cambios son personalizados solo para ti y no afectan a otros usuarios.',
                'contact.edit.profileInfo': 'Información del Perfil',
                'export.title': 'Exportar Conversación',
                'export.description': 'Selecciona el formato en el que deseas exportar esta conversación:',
                'export.progress': 'Exportando...',
                'export.format.pdf': 'PDF',
                'export.format.pdf.description': 'Documento PDF con todas las imágenes y archivos',
                'export.format.html': 'HTML',
                'export.format.html.description': 'Archivo HTML que puedes abrir en cualquier navegador',
                'export.info': 'La exportación incluirá todos los mensajes, imágenes y archivos de esta conversación.',
                'export.pro_required.title': 'Exportar conversación',
                'export.pro_required.message': 'Esta función está disponible en el plan PRO.',
                'dashboard.title': 'Dashboard',
                'dashboard.planUsage': 'Uso del plan',
                'dashboard.filesSummary': 'Mis archivos',
                'dashboard.promotions': 'Promociones',
                'dashboard.sessions': 'Sesiones activas',
                'dashboard.explore': 'Explorar',
                'dashboard.noSessions': 'Sin sesiones activas',
                'dashboard.welcomeTitle': 'Bienvenido a ArChat®',
                'dashboard.welcomeSubtitle': 'Comunicate en cualquier idioma.',
                'dashboard.stepInvite': 'Paso 1: invitá a tu primer contacto',
                'dashboard.stepMessage': 'Paso 2: enviá tu primer mensaje',
                'dashboard.inviteContact': 'Invitar contacto',
                'dashboard.exploreArChat': 'Explorar ArChat',
                'dashboard.promotionsTitle': 'Promociones',
                'dashboard.promotionsText': 'Resumen del programa de invitaciones y recompensas.',
                'dashboard.viewPromotions': 'Ver promociones',
                'dashboard.usageTitle': 'Uso del plan',
                'dashboard.sessionsTitle': 'Sesiones activas',
                'dashboard.sessionsEmpty': 'Sin sesiones activas',
                'dashboard.filesTitle': 'Mis archivos',
                'dashboard.viewFiles': 'Ver mis archivos',
                'dashboard.noBlocks': 'No hay bloques activos. Activá al menos uno en Configuración.',
                'dashboard.openSettings': 'Abrir configuración',
                'dashboard.goToContacts': 'Ir a contactos',
                'dashboard.recentInbound.title': 'Últimos mensajes recibidos',
                'dashboard.recentInbound.empty': 'No tenés mensajes recibidos recientes.',
                'dashboard.recentInbound.error': 'No se pudieron cargar los mensajes.',
                'dashboard.recentInbound.previewPhoto': 'Foto',
                'dashboard.recentInbound.previewFile': 'Archivo',
                'dashboard.recentInbound.previewPdf': 'PDF',
                'dashboard.recentInbound.previewUnavailable': 'Mensaje no disponible',
                'dashboard.recentInbound.readTitle': 'Leído',
                'dashboard.recentInbound.unreadTitle': 'Sin leer',
                'dashboard.recentConversations.title': 'Conversaciones recientes',
                'dashboard.recentConversations.empty': 'No hay conversaciones para mostrar.',
                'dashboard.recentConversations.error': 'No se pudieron cargar las conversaciones.',
                'dashboard.filesVisible': 'Archivos visibles',
                'dashboard.filesSampleNote': 'El conteo proviene de la primera página (hasta 500+).',
                'dashboard.loading': 'Cargando datos...',
                'dashboard.error.title': 'Error',
                'dashboard.error.load': 'No se pudieron cargar los datos de uso',
                'dashboard.error.generic': 'Error al cargar el dashboard',
                'dashboard.error.no_data': 'No se pudieron cargar los datos',
                'dashboard.retry': 'Reintentar',
                'dashboard.unlimited': 'Ilimitado',
                'dashboard.not_available': 'No disponible',
                'dashboard.plan.free': 'FREE',
                'dashboard.plan.foundation': 'FOUNDATION',
                'dashboard.plan.pro': 'PRO',
                'dashboard.plan.enterprise': 'ENTERPRISE',
                'dashboard.card.contacts': 'Contactos',
                'dashboard.card.chars': 'Caracteres',
                'dashboard.card.chars_month': 'Caracteres este mes',
                'dashboard.card.storage': 'Almacenamiento',
                'dashboard.card.devices': 'Dispositivos activos',
                'dashboard.contacts': 'Contactos',
                'dashboard.characters': 'Caracteres',
                'dashboard.storage': 'Almacenamiento',
                'dashboard.active_devices': 'Dispositivos activos',
                'dashboard.need_more_resources': '¿Necesitás más recursos?',
                'dashboard.upgrade_message': 'Actualizá tu plan (FOUNDATION o PRO) para obtener más contactos, caracteres, almacenamiento y dispositivos activos.',
                'dashboard.upgrade_button': 'Pasar a PRO',
                'dashboard.upgrade_button_pro': 'Pasar a PRO',
                'dashboard.upgrade_button_foundation': 'Pasar a FOUNDATION',
                'dashboard.admin.title': 'Métricas de crecimiento',
                'dashboard.admin.newUsersToday': 'Nuevos usuarios hoy',
                'dashboard.admin.messagesSentToday': 'Mensajes enviados hoy',
                'dashboard.admin.translationsUsed': 'Traducciones usadas',
                'dashboard.admin.invitesCreated': 'Invitaciones creadas',
                'dashboard.admin.invitesValidated': 'Invitaciones validadas',
                'dashboard.admin.inviteConversion': 'Conversión de invitaciones',
                'dashboard.admin.kFactor': 'K-Factor',
                'dashboard.admin.newUsers': 'Nuevos usuarios',
                'dashboard.admin.messagesSent': 'Mensajes enviados',
                'dashboard.admin.noData': 'Sin datos',
                'dashboard.admin.kFactor.viral': 'Viral',
                'dashboard.admin.kFactor.stable': 'Estable',
                'dashboard.admin.kFactor.low': 'Bajo',
                'dashboard.admin.emailMetrics': 'Métricas de email',
                'dashboard.admin.email.sent': 'Enviados',
                'dashboard.admin.email.delivered': 'Entregados',
                'dashboard.admin.email.opened': 'Abiertos',
                'dashboard.admin.email.clicked': 'Clics',
                'dashboard.admin.email.bounced': 'Rebotados',
                'dashboard.admin.email.deliveryRate': 'Tasa de entrega',
                'dashboard.admin.email.openRate': 'Tasa de apertura',
                'dashboard.admin.email.bounceRate': 'Tasa de rebote',
                'dashboard.admin.funnelMetrics': 'Métricas de funnel',
                'dashboard.admin.funnel.registered': 'Registrados',
                'dashboard.admin.funnel.confirmed': 'Confirmados',
                'dashboard.admin.funnel.loggedIn': 'Primer login',
                'dashboard.admin.funnel.firstMessage': 'Primer mensaje',
                'dashboard.admin.funnel.abandoned': 'Abandonados',
                'dashboard.admin.funnel.conversionRate': 'Tasa de conversión',
                'dashboard.admin.funnel.activationRate': 'Tasa de activación',
                'dashboard.admin.funnel.dropoffRate': 'Tasa de abandono',
                'dashboard.admin.loading': 'Cargando métricas...',
                'dashboard.admin.errorLoad': 'No se pudo cargar el dashboard de métricas.',
                'dashboard.admin.growthViral': 'Crecimiento viral',
                'dashboard.admin.growthStable': 'Crecimiento estable',
                'dashboard.admin.growthLow': 'Crecimiento bajo',
                'dashboard.upgrade.title': '¿Necesitas más recursos?',
                'dashboard.upgrade.message': 'Mejorá tu plan (FOUNDATION o PRO) para obtener más contactos, caracteres, almacenamiento y dispositivos activos.',
                'dashboard.upgrade.button': 'Mejorar Plan',
                'upgrade.title': 'Mejorar Plan',
                'upgrade.close': 'Cerrar',
                'upgrade.cancel': 'Cancelar',
                'upgrade.activate': 'Activar Plan PRO',
                'upgrade.activating': 'Activando...',
                'upgrade.comparison.title': 'Comparación de Planes',
                'upgrade.free.label': 'Plan Gratuito',
                'upgrade.free.limits.contacts': '2 contactos máximo',
                'upgrade.free.limits.conversations': '2 conversaciones máximo',
                'upgrade.free.limits.no_export': 'Sin exportación de datos',
                'upgrade.free.limits.no_advanced': 'Sin funciones avanzadas',
                'upgrade.pro.label': 'Plan Pro',
                'upgrade.pro.recommended': 'RECOMENDADO',
                'upgrade.pro.benefits.contacts': 'Hasta 100 contactos por usuario',
                'upgrade.pro.benefits.contacts.desc': 'Límite premium según el motor de planes (PlanConstants)',
                'upgrade.pro.benefits.conversations': 'Conversaciones y chats ilimitados (tenant)',
                'upgrade.pro.benefits.conversations.desc': 'Con límites de mensajes 1.667/día y 50.000/mes (tenant)',
                'upgrade.pro.benefits.export': 'Exportación de conversaciones',
                'upgrade.pro.benefits.export.desc': 'Exporta tus conversaciones en múltiples formatos (PDF, TXT, JSON)',
                'upgrade.pro.benefits.notifications': 'Notificaciones avanzadas',
                'upgrade.pro.benefits.notifications.desc': 'Notificaciones personalizadas y configuración avanzada',
                'upgrade.pro.benefits.translation': 'Traducción automática',
                'upgrade.pro.benefits.translation.desc': 'Incluida según límites del plan premium',
                'upgrade.pro.benefits.files': 'Archivos adjuntos',
                'upgrade.pro.benefits.files.desc': 'Hasta 50 MB de almacenamiento (tenant), según política del plan',
                'upgrade.pro.benefits.themes': 'Temas personalizados',
                'upgrade.pro.benefits.themes.desc': 'Acceso a todos los temas y personalización avanzada',
                'upgrade.pro.benefits.security': 'Seguridad avanzada',
                'upgrade.pro.benefits.security.desc': 'Protección adicional y funciones de privacidad mejoradas',
                'upgrade.pro.benefits.analytics': 'Estadísticas y análisis',
                'upgrade.pro.benefits.analytics.desc': 'Accede a estadísticas detalladas de tu actividad',
                'upgrade.pro.benefits.priority': 'Soporte prioritario',
                'upgrade.pro.benefits.priority.desc': 'Atención prioritaria y respuesta rápida a tus consultas',
                'upgrade.enterprise.label': 'Plan Enterprise',
                'upgrade.enterprise.title': 'ENTERPRISE',
                'upgrade.enterprise.benefits.contacts': 'Contactos ilimitados',
                'upgrade.enterprise.benefits.support': 'Soporte prioritario 24/7',
                'upgrade.enterprise.benefits.custom': 'Soluciones personalizadas',
                'upgrade.enterprise.benefits.advanced': 'Funciones avanzadas empresariales',
                'upgrade.enterprise.benefits.integration': 'Integraciones personalizadas',
                'upgrade.enterprise.benefits.dedicated': 'Soporte dedicado',
                'upgrade.success.title': 'Plan PRO Activado',
                'upgrade.success.message': 'Tu plan ha sido actualizado a PRO. Disfruta de todas las funcionalidades ilimitadas.',
                'upgrade.error.title': 'Error al Activar PRO',
                'upgrade.error.message': 'No se pudo actualizar el plan. Por favor, intenta nuevamente.',
                'upgrade.error.generic': 'Ocurrió un error inesperado. Por favor, intenta nuevamente.',
                'upgrade.benefits.contacts': 'Hasta 100 contactos por usuario',
                'upgrade.benefits.contacts.desc': 'Límite premium según el motor de planes (PlanConstants)',
                'upgrade.benefits.conversations': 'Conversaciones y chats ilimitados (tenant)',
                'upgrade.benefits.conversations.desc': 'Con límites de mensajes 1.667/día y 50.000/mes (tenant)',
                'upgrade.benefits.export': 'Exportación de conversaciones',
                'upgrade.benefits.export.desc': 'Exporta tus conversaciones en múltiples formatos (PDF, TXT, JSON)',
                'upgrade.benefits.notifications': 'Notificaciones avanzadas',
                'upgrade.benefits.notifications.desc': 'Notificaciones personalizadas y configuración avanzada',
                'upgrade.benefits.translation': 'Traducción automática',
                'upgrade.benefits.translation.desc': 'Incluida según límites del plan premium',
                'upgrade.benefits.files': 'Archivos adjuntos',
                'upgrade.benefits.files.desc': 'Hasta 50 MB de almacenamiento (tenant), según política del plan',
                'upgrade.benefits.themes': 'Temas personalizados',
                'upgrade.benefits.themes.desc': 'Acceso a todos los temas y personalización avanzada',
                'upgrade.benefits.security': 'Seguridad avanzada',
                'upgrade.benefits.security.desc': 'Protección adicional y funciones de privacidad mejoradas',
                'upgrade.benefits.analytics': 'Estadísticas y análisis',
                'upgrade.benefits.analytics.desc': 'Accede a estadísticas detalladas de tu actividad',
                'upgrade.benefits.priority': 'Soporte prioritario',
                'upgrade.benefits.priority.desc': 'Atención prioritaria y respuesta rápida a tus consultas',
                'upgrade.limits.contacts': '2 contactos máximo',
                'upgrade.limits.conversations': '2 conversaciones máximo',
                'upgrade.limits.no_export': 'Sin exportación de datos',
                'upgrade.limits.no_advanced': 'Sin funciones avanzadas',
                // API Error Messages
                'api.error.image_processing_not_available': 'El procesamiento de imágenes no está disponible en el servidor',
                'api.error.image_functions_not_available': 'Funciones de procesamiento de imágenes no disponibles',
                'api.error.method_not_allowed': 'Método no permitido',
                'api.error.user_not_identified': 'Usuario no identificado',
                'api.error.upload_file_too_large_php': 'El archivo excede el tamaño máximo permitido por PHP',
                'api.error.upload_file_too_large_form': 'El archivo excede el tamaño máximo permitido por el formulario',
                'api.error.upload_file_partial': 'El archivo se subió parcialmente',
                'api.error.upload_no_file': 'No se subió ningún archivo',
                'api.error.upload_no_temp_dir': 'Falta el directorio temporal',
                'api.error.upload_cant_write': 'Error al escribir el archivo en disco',
                'api.error.upload_extension_stopped': 'Una extensión de PHP detuvo la subida',
                'api.error.upload_generic': 'Error en subida de archivo',
                'api.error.file_type_not_allowed': 'Tipo de archivo no permitido. Solo se permiten imágenes (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'El archivo es demasiado grande (máx 10MB)',
                'api.error.storage_limit_exceeded': 'Límite de almacenamiento excedido. Mejora tu plan para subir más archivos.',
                'api.error.user_not_found': 'Usuario no encontrado o inactivo',
                'api.error.image_directory_access': 'Error al acceder al directorio de imágenes',
                'api.error.file_extension_not_allowed': 'Extensión de archivo no permitida',
                'api.error.temp_file_save': 'Error al guardar el archivo temporal',
                'api.error.image_processing': 'Error al procesar la imagen',
                'api.error.database_update': 'Error al actualizar la base de datos',
                'api.error.internal_server_error': 'Error interno del servidor',
                'api.error.internal_server_error_debug': 'Error interno del servidor',
                'api.error.user_id_required': 'ID de usuario requerido',
                'api.error.profile_not_found': 'Perfil no encontrado',
                'api.error.profile_load_failed': 'Error al cargar el perfil',
                'api.error.invalid_data': 'Datos inválidos',
                'api.error.validation_errors': 'Errores de validación',
                'api.error.profile_update_failed': 'No se pudo actualizar el perfil',
                'api.error.profile_update_error': 'Error al actualizar el perfil',
                // API Success Messages
                'api.success.photo_updated': 'Foto actualizada',
                'api.success.profile_loaded': 'Perfil cargado correctamente',
                'api.success.profile_updated': 'Perfil actualizado correctamente',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'Límite de dispositivos alcanzado',
                'errors.deviceLimit.solution': 'Para continuar, cerrá sesión en otros dispositivos o mejorá tu plan.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'Límite del plan alcanzado',
                'plan.errors.deviceLimit.message': 'Tu plan actual tiene un límite en la cantidad de dispositivos conectados simultáneamente.',
                'plan.errors.deviceLimit.solution': 'Para continuar, cerrá sesión en otros dispositivos o mejorá tu plan a PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'Límite de contactos alcanzado',
                'plan.errors.contactsLimit.message': 'Tu plan actual tiene un límite en la cantidad de contactos que podés tener.',
                'plan.errors.contactsLimit.solution': 'Para agregar más contactos, mejorá tu plan a PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'Límite de invitaciones alcanzado',
                'plan.errors.invitationsLimit.message': 'Tu plan actual tiene un límite en la cantidad de invitaciones que podés enviar por día.',
                'plan.errors.invitationsLimit.solution': 'Para enviar más invitaciones, mejorá tu plan a PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'Límite de mensajes alcanzado',
                'plan.errors.messagesLimit.message': 'Tu plan actual tiene un límite en la cantidad de mensajes que podés enviar por día.',
                'plan.errors.messagesLimit.solution': 'Para enviar más mensajes, mejorá tu plan a PRO.',
                // Plan Errors - Translation
                'plan.errors.translationNotAllowed.title': 'Traducción no disponible',
                'plan.errors.translationNotAllowed.message': 'Tu plan actual no incluye traducción automática entre idiomas.',
                'plan.errors.translationNotAllowed.solution': 'Para usar traducción automática, mejorá tu plan.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'Límite de almacenamiento alcanzado',
                'plan.errors.storageLimit.message': 'Tu plan actual tiene un límite en la cantidad de almacenamiento disponible.',
                'plan.errors.storageLimit.solution': 'Para obtener más almacenamiento, mejorá tu plan a PRO.',
                // Plan Errors - Chats/Conversations Limit
                'plan.errors.chatsLimit.title': 'Límite de conversaciones alcanzado',
                'plan.errors.chatsLimit.message': 'Tu plan actual tiene un límite en la cantidad de conversaciones que podés tener.',
                'plan.errors.chatsLimit.solution': 'Para crear más conversaciones, mejorá tu plan a PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'Mejora de plan requerida',
                'plan.errors.upgradeRequired.message': 'Esta función requiere un plan superior al que tenés actualmente.',
                'plan.errors.upgradeRequired.solution': 'Mejorá tu plan a PRO para acceder a esta función.',
                // Error Messages - Network
                'errors.network.title': 'Error de conexión',
                'errors.network.message': 'No se pudo conectar con el servidor. Verificá tu conexión a internet.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'Error del servidor',
                'errors.server.invalidResponse.message': 'El servidor devolvió una respuesta inválida. Intentá nuevamente.',
                // Error Messages - Generic
                'errors.generic': 'Ocurrió un error inesperado. Intenta nuevamente.',
                'errors.modal.title': 'Error',
                'errors.modal.copyDetails': 'Copiar detalle',
                'errors.modal.close': 'Cerrar',
                'errors.modal.reportSupport': 'Reportar a soporte',
                'errors.modal.code': 'Código',
                'errors.modal.message': 'Mensaje',
                'errors.modal.path': 'Ruta',
                'errors.modal.time': 'Hora',
                'errors.modal.timestamp': 'Timestamp',
                'errors.modal.copied': 'Detalle copiado',
                'errors.generic.title': 'Error',
                'errors.generic.message': 'Ocurrió un error. Intentá nuevamente.',
                'errors.network': 'No se pudo conectar con el servidor. Verificá tu conexión.',
                'errors.unexpected': 'Ocurrió un error inesperado. Intentá nuevamente.',
                'errors.boundary.title': 'ERROR DE REACT CAPTURADO',
                'errors.boundary.request_id': 'X-Request-ID:',
                'errors.boundary.correlate': 'Correlacionar con backend/logs/structured.log',
                'errors.boundary.message_label': 'Mensaje:',
                'errors.boundary.stack_trace': 'Stack trace',
                'errors.boundary.component_stack': 'Component stack',
                'errors.boundary.empty': '(vacío)',
                'errors.boundary.reload_page': 'Recargar página',
                'errors.ui_boundary.refresh': 'Error de interfaz de ArChat — recarga la página',
                'bootstrap.error.title': 'ArChat® — Error de arranque',
                'common.reload': 'Recargar',
                'errors.avatarTooLarge': 'La imagen supera el tamaño permitido de 2MB.',
                'errors.avatarTooLarge.title': 'Imagen demasiado grande',
                'errors.avatarTooLarge.message': 'La imagen supera el tamaño permitido de 2MB.',
                'errors.invalidImageType': 'El archivo seleccionado no es una imagen válida.',
                'errors.invalidImageType.title': 'Archivo no válido',
                'errors.invalidImageType.message': 'El archivo seleccionado no es una imagen válida.',
                'errors.uploadFailed': 'No se pudo subir la imagen. Intenta nuevamente.',
                'errors.uploadFailed.title': 'Error al subir',
                'errors.uploadFailed.message': 'No se pudo subir la imagen. Intenta nuevamente.',
                'errors.conversationCreate': 'Error al crear la conversación. Por favor, intenta nuevamente.',
                'errors.conversationInvalidId': 'ID de conversación inválido.',
                'errors.conversationOpen': 'Error al abrir la conversación. Por favor, intenta nuevamente.',
                'errors.favoriteUpdate': 'No se pudo actualizar favorito',
                'errors.blockUpdate': 'No se pudo actualizar bloqueo',
                'errors.messageEdit': 'Error al editar el mensaje.',
                'errors.generic.403.title': 'Error de acceso',
                'errors.generic.403.message': 'No tenés permiso para realizar esta acción.',
                'errors.saas_max_users': 'Se alcanzó el límite de usuarios del plan ({current}/{limit}).',
                'errors.tenant_frozen': 'El tenant se encuentra temporalmente bloqueado.',
                'errors.auth_invalid_credentials': 'Usuario o contraseña incorrectos.',
                'errors.foundation_sold_out': 'Los cupos Founder se encuentran agotados.',
                'errors.unexpected_error': 'Ocurrió un error inesperado. Intentá de nuevo.',
                // Cuenta inactiva - reactivación
                'errors.accountInactive.title': 'La cuenta está inactiva. Completá tu email para reactivarla.',
                'errors.userInactive.title': 'Cuenta desactivada',
                'errors.tenantMismatch.title': 'Error de tenant',
                'errors.accountInactive.activate': 'Activar ahora',
                'errors.accountInactive.accept': 'Aceptar',
                'errors.accountInactive.success': 'Cuenta reactivada. Ya podés iniciar sesión.',
                'errors.accountInactive.fail': 'No se pudo reactivar la cuenta. Intentá nuevamente.',
                'errors.accountInactive.completeSuccess': 'Cuenta activada con tu email. Ya podés iniciar sesión.',
                'errors.accountInactive.completeFail': 'No se pudo completar la activación. Revisá el email e intentá de nuevo.',
                'appearance.theme.system': 'Sistema',
                'appearance.theme.corporate': 'Corporativo',
                'theme.system': 'Sistema',
                'theme.corporate': 'Corporativo',
                // Founder (niveles 1–150)
                'founder.title': 'FOUNDATION (Founder)',
                'founder.subtitle': 'Apoyás el proyecto desde el inicio con precio de por vida.',
                'founder.whatIs': 'Los primeros 150 usuarios obtienen el plan FOUNDATION a precio reducido de por vida.',
                'founder.howItWorks': 'Tu nivel Founder depende de tu posición (1 a 150).',
                'founder.benefitsTitle': 'Beneficios',
                'founder.benefitPrice': '$15 / mes (tarifa Founder)',
                'founder.benefitFeatures': 'Incluye todas las funciones del plan PRO.',
                'founder.limit': 'Solo existen 150 plazas Founder.',
                'founder.cancelRule': 'Si cancelás, perdés el estado Founder mientras estés dado de baja.',
                'founder.rejoinRule': 'Si vuelve a haber cupo disponible, podés reactivarlo y volver a ser Founder automáticamente.',
                'founder.tiers.title': 'Niveles Founder',
                'founder.tiers.legendary.name': 'LEGENDARY Founder',
                'founder.tiers.legendary.range': 'Posición 1–25',
                'founder.tiers.legendary.desc': 'Los primeros en apoyar el proyecto. Máxima prioridad histórica.',
                'founder.tiers.early.name': 'EARLY Founder',
                'founder.tiers.early.range': 'Posición 26–75',
                'founder.tiers.early.desc': 'Apoyo temprano con reconocimiento especial.',
                'founder.tiers.founder.name': 'Founder',
                'founder.tiers.founder.range': 'Posición 76–150',
                'founder.tiers.founder.desc': 'Cupo Founder dentro de las 150 plazas.',
                'founder.whatIsLink': '¿Qué es Founder?',
                'founder.viewTiers': 'Ver niveles Founder',
                'founder.modalClose': 'Cerrar',
                'founder.urgency.lastSlots': 'Últimos cupos Founder disponibles',
                'founder.positionLabel': 'Founder #{position} / {limit}',
                'founder.leaderboard.title': 'Top Founders',
                'plan.free_characters_month': '30,000 characters / month',
                'plan.pro_characters_month': '300,000 characters / month',
                'admin.access_denied.message': 'Message',
                'admin.access_denied.title': 'Title',
                'admin.action.change_plan': 'Change plan',
                'admin.action.reactivate': 'Reactivate',
                'admin.action.suspend': 'Suspend',
                'admin.action.view': 'View',
                'admin.confirm.change_plan.message': 'Message',
                'admin.confirm.change_plan.title': 'Title',
                'admin.confirm.suspend.message': 'Message',
                'admin.confirm.suspend.title': 'Title',
                'admin.details.created': 'Created',
                'admin.details.current_plan': 'Current plan',
                'admin.details.domain': 'Domain',
                'admin.details.last_activity': 'Last activity',
                'admin.details.name': 'Name',
                'admin.details.plan': 'Plan',
                'admin.details.status': 'Status',
                'admin.details.subscription': 'Subscription',
                'admin.details.tenant_id': 'Tenant id',
                'admin.details.tenant_info': 'Tenant info',
                'admin.details.usage': 'Usage',
                'admin.error.change_plan': 'Change plan',
                'admin.error.generic': 'Generic',
                'admin.error.load_details': 'Load details',
                'admin.error.load_tenants': 'Load tenants',
                'admin.error.reactivate': 'Reactivate',
                'admin.error.suspend': 'Suspend',
                'admin.error.title': 'Title',
                'admin.filter.active': 'Active',
                'admin.filter.all_plans': 'All plans',
                'admin.filter.all_status': 'All status',
                'admin.filter.suspended': 'Suspended',
                'admin.limit.devices': 'Devices',
                'admin.limit.invitations': 'Invitations',
                'admin.limit.messages': 'Messages',
                'admin.limit.storage': 'Storage',
                'admin.limit.users': 'Users',
                'admin.loading': 'Loading',
                'admin.no_tenants': 'No tenants',
                'admin.plan.enterprise': 'Enterprise',
                'admin.plan.free': 'Free',
                'admin.plan.pro': 'Pro',
                'admin.status.active': 'Active',
                'admin.status.suspended': 'Suspended',
                'admin.subscription.id': 'Referencia de suscripción (externa)',
                'admin.subscription.last_payment': 'Last payment',
                'admin.subscription.status': 'Status',
                'admin.subtitle': 'Subtitle',
                'admin.success.plan_changed': 'Plan changed',
                'admin.success.tenant_reactivated': 'Tenant reactivated',
                'admin.success.tenant_suspended': 'Tenant suspended',
                'admin.success.title': 'Title',
                'admin.table.actions': 'Actions',
                'admin.table.messages': 'Messages',
                'admin.table.name': 'Name',
                'admin.table.plan': 'Plan',
                'admin.table.status': 'Status',
                'admin.table.storage': 'Storage',
                'admin.table.tenant_id': 'Tenant id',
                'admin.table.users': 'Users',
                'admin.title': 'Title',
                'admin.usage.devices': 'Devices',
                'admin.usage.invitations': 'Invitations',
                'admin.usage.messages': 'Messages',
                'admin.usage.storage': 'Storage',
                'admin.usage.users': 'Users',
                'auth.login': 'Login',
                'auth.register': 'Register',
                'auth.reset_password': 'Reset password',
                'billing.cancel.button': 'Button',
                'billing.cancel.canceling': 'Canceling',
                'billing.cancel.confirm': 'Confirm',
                'billing.cancel.error': 'Error',
                'billing.cancel.success': 'Success',
                'billing.character_billing.characters_used': 'Characters used',
                'billing.character_billing.consumption_pct': 'Consumption pct',
                'billing.character_billing.days_remaining': 'Days remaining',
                'billing.character_billing.deletion_date': 'Deletion date',
                'billing.character_billing.period_start': 'Period start',
                'billing.character_billing.renewal_date': 'Renewal date',
                'billing.character_billing.title': 'Title',
                'billing.current_plan': 'Current plan',
                'billing.founder_badge': 'Founder badge',
                'billing.no_plans': 'No plans',
                'billing.subscription.canceled': 'Cancelación programada',
                'billing.subscription.canceled_note': 'Tu suscripción se cancelará al final del período. Podés seguir usando tu plan hasta entonces.',
                'billing.subscription.cancel_scheduled_date': 'Tu suscripción está programada para cancelarse el {{date}}. Podés seguir usando tu plan hasta ese momento.',
                'billing.subscription.cancel_scheduled_badge': 'Se cancela el {{date}}',
                'billing.scheduled.plan_after_cancel_label': 'Plan al finalizar el período:',
                'billing.scheduled.plan_free': 'FREE (gratuito)',
                'billing.scheduled.plan_foundation': 'FOUNDATION',
                'billing.scheduled.switch_to_foundation': 'Cambiar a FOUNDATION',
                'billing.scheduled.switch_to_free': 'Cambiar a FREE',
                'billing.scheduled.foundation_full_title': 'FOUNDATION no disponible',
                'billing.scheduled.foundation_full_message': 'No hay cupos FOUNDATION disponibles en este momento. Tu plan bajará a FREE al finalizar el período.',
                'billing.scheduled.saving': 'Guardando...',
                'billing.scheduled.error_title': 'Error al cambiar plan',
                'billing.scheduled.error_generic': 'No se pudo cambiar el plan programado. Intentá de nuevo.',
                'billing.cancel_scheduled.title': 'Cancelación programada',
                'billing.cancel_scheduled.desc': 'Tu suscripción se cancelará el {{date}}. Podés seguir usando tu plan actual hasta ese momento.',
                'billing.cancel_scheduled.no_new_plan_until_end': 'Hasta que venza esta suscripción no podrás contratar otro plan.',
                'billing.cancel_scheduled.free_fallback': 'Si no renovás ningún plan, tu cuenta continuará en FREE con las limitaciones correspondientes.',
                'billing.cancel_scheduled.profile_deactivation_hint': 'También podés darte de baja de la plataforma desde tu perfil.',
                'billing.cancel_scheduled.default_free': 'Al finalizar el período: FREE (gratuito)',
                'billing.subscription.next_payment': 'Next payment',
                'billing.subscription.plan': 'Plan',
                'billing.subscription.price': 'Precio',
                'billing.subscription.started': 'Started',
                'billing.subscription.status': 'Status',
                'billing.subscription.mp_flow.subscribe_failed': 'No se pudo iniciar la suscripción. Intentá nuevamente.',
                'billing.subscription.mp_flow.change_plan_failed': 'No se pudo cambiar el plan. Intentá nuevamente.',
                'billing.subscription.mp_status.pending': 'Pendiente',
                'billing.subscription.mp_status.authorized': 'Autorizada',
                'billing.subscription.mp_status.active': 'Activa',
                'billing.subscription.mp_status.paused': 'Pausada',
                'billing.subscription.mp_status.cancelled': 'Cancelada',
                'billing.subscription.mp_status.inactive': 'Inactiva',
                'billing.subscription.mp_status.unknown': 'Desconocido',
                'billing.unlimited': 'Unlimited',
                'billing.update_plan': 'Update plan',
                'billing.update_plan_modal.title': 'Title',
                'billing.usage.loading': 'Loading',
                'common.accept': 'Accept',
                'common.confirmPassword': 'ConfirmPassword',
                'common.continue': 'Continuar',
                'common.error': 'Error',
                'dashboard.upgrade.to_plan': 'To plan',
                'emoji.noResults': 'NoResults',
                'emoji.pick': 'Pick',
                'export.restricted.message': 'Message',
                'export.restricted.title': 'Title',
                'export.restricted.upgrade': 'Upgrade',
                'founder.*': '*',
                'help.faq.a1': 'A1',
                'help.faq.a2': 'A2',
                'help.faq.a3': 'A3',
                'help.faq.a4': 'A4',
                'help.faq.a5': 'A5',
                'help.faq.a6': 'A6',
                'help.faq.a7': 'A7',
                'help.faq.q1': 'Q1',
                'help.faq.q2': 'Q2',
                'help.faq.q3': 'Q3',
                'help.faq.q4': 'Q4',
                'help.faq.q5': 'Q5',
                'help.faq.q6': 'Q6',
                'help.faq.q7': 'Q7',
                'help.faq.title': 'Title',
                'help.howWorks.step4.point7': 'Point7',
                'help.message_time_context.free_vs_pro': 'Free vs pro',
                'help.message_time_context.point5': 'Point5',
                'help.plans.enterprise.benefits': 'Benefits',
                'help.plans.enterprise.description': 'Description',
                'help.plans.enterprise.title': 'Title',
                'help.plans.foundation.devices': 'Devices',
                'help.plans.free.description': 'Description',
                'help.plans.free.devices': 'Devices',
                'help.plans.free.limits': 'Limits',
                'help.plans.free.title': 'Title',
                'help.plans.intro': 'Intro',
                'help.plans.pro.benefits': 'Benefits',
                'help.plans.pro.description': 'Description',
                'help.plans.pro.devices': 'Devices',
                'help.plans.pro.price': '$19 / mes',
                'help.plans.pro.title': 'Title',
                'help.plans.pro.upgrade': 'Upgrade',
                'help.plans.title': 'Title',
                'help.plans.urgent_slots_badge': 'Urgent slots badge',
                'help.slogan.final': 'Final',
                'help.suggestions.point1': 'Point1',
                'help.suggestions.point2': 'Point2',
                'help.suggestions.title': 'Title',
                'invitation.already_contact_added': 'Already contact added',
                'invitation.already_contact_title': 'Already contact title',
                'invitation.already_pending': 'Already pending',
                'invitation.language.invalid': 'Invalid',
                'message.send': 'Send',
                'message.sendFile': 'SendFile',
                'messages.conversations': 'Conversations',
                'messages.no_conversations_subtitle': 'No conversations subtitle',
                'messages.no_conversations_title': 'No conversations title',
                'presence.custom.edit': 'Edit',
                'profile.enrichment.country': 'Country',
                'profile.enrichment.country.select': 'Select',
                'profile.enrichment.description': 'Description',
                'profile.enrichment.org_size': 'Org size',
                'profile.enrichment.org_size.placeholder': 'Placeholder',
                'profile.enrichment.save': 'Save',
                'profile.enrichment.skip': 'Skip',
                'profile.enrichment.title': 'Title',
                'profile.enrichment.usage_type.label': 'Label',
                'profile.enrichment.usage_type.placeholder': 'Placeholder',
                'profile.founderPosition': 'FounderPosition',
                'settings.confirmations.description': 'Description',
                'settings.confirmations.disable': 'Disable',
                'settings.confirmations.title': 'Title',
                'settings.confirmations.updated': 'Updated',
                'settings.title': 'Title',
                'theme.description': 'Description',
                'google.missing_client_id': 'Acceso con Google no está disponible en este build: falta VITE_GOOGLE_CLIENT_ID (o googleClientId por tenant en __ARCHAT_TENANT_CONFIG__).',
                'google.unavailable_tenant': 'Google is unavailable for this tenant.',
                'google.unavailable': 'Google unavailable.',
                'google.verify_client_id': 'Verify the Client ID in Google Cloud Console.',
                'google.login_aria': 'Iniciar sesión con Google',
                'message.preview_alt': 'Preview',
                'message.image_attachment_alt': 'Attached image',
                'profile.avatar.alt': 'avatar',
                'plan.name.free': 'FREE',
                'plan.name.pro': 'PRO',
                'plan.name.foundation': 'FOUNDATION',
                'plan.name.enterprise': 'ENTERPRISE',
                'register.emailPlaceholder': 'you@email.com',
                'invitation.top.loading': 'Loading top inviters...',
                'invitation.top.empty': 'No featured inviters yet.',
                'invitation.contacts.title': 'Invite contacts',
                'invitation.contacts.safe_phase_note': 'Safe phase active: pending benefits without impact on real limits.',
                'invitation.contacts.generate_code': 'Generate code/link',
                'invitation.contacts.refresh_top3': 'Refresh Top 3',
                'invitation.contacts.hide_full_ranking': 'Hide full ranking',
                'invitation.contacts.show_full_ranking': 'Show full ranking',
                'invitation.contacts.hide_metrics_dashboard': 'Hide metrics dashboard',
                'invitation.contacts.show_metrics_dashboard': 'Show metrics dashboard',
                'invitation.contacts.prepared_link_label': 'Prepared link:',
                'invitation.contacts.email_placeholder': 'email@domain.com',
                'invitation.contacts.register_pending': 'Register pending invitation',
                'invitation.contacts.status_summary': 'Status summary',
                'invitation.contacts.sent_invitations': 'Sent invitations',
                'invitation.contacts.invited_email': 'Invited email',
                'invitation.contacts.code': 'Code',
                'invitation.contacts.no_sent_invitations': 'No sent invitations yet.',
                'invitation.contacts.simulated_rewards': 'Simulated rewards obtained',
                'invitation.contacts.no_simulated_rewards': 'No simulated rewards yet.',
                'common.id': 'ID',
                'common.created': 'Created',
                'plan.pro_contacts': 'Hasta 100 contactos por usuario',
                'common.status': 'Status',
                'login.prompt_create_account_with_name': 'Do you want to create an account with this name?',

                'reviews.menu_title': 'Reseñas',
                'reviews.rate_archat': 'Calificar ArChat',
                'reviews.title': 'Reseñas de ArChat',
                'reviews.create_title': '¿Cómo calificarías ArChat?',
                'reviews.edit_title': 'Editar mi reseña',
                'reviews.comment_placeholder': 'Contanos tu experiencia (opcional)...',
                'reviews.submit_btn': 'Enviar reseña',
                'reviews.update_btn': 'Actualizar',
                'reviews.thank_you': '¡Gracias por tu reseña!',
                'reviews.submitted_message': 'Tu opinión nos ayuda a mejorar.',
                'reviews.error_select_rating': 'Seleccioná una calificación',
                'reviews.error_generic': 'Error al enviar la reseña',
                'reviews.prompt_message': '¿Te gusta ArChat? ¡Dejá tu reseña!',
                'reviews.rate_now': 'Calificar',
                'reviews.later': 'Más tarde',
                'reviews.write_review': 'Escribir reseña',
                'reviews.edit_my_review': 'Editar mi reseña',
                'reviews.my_review': 'Mi reseña',
                'reviews.no_reviews': 'Aún no hay reseñas. ¡Sé el primero!',
                'reviews.review_singular': 'reseña',
                'reviews.review_plural': 'reseñas',
                'reviews.verified': 'Verificada',
                'reviews.anonymous': 'Anónimo',
                'files.storageUsed': 'Espacio usado',
                'files.planQuota': 'Cupo del plan',
                'files.availableStorage': 'Disponible',
                'files.usagePercent': 'usado',
                'files.unlimited': 'Ilimitado',
                'files.sentBy': 'Enviado por',
                'files.unknownUser': 'Usuario',
                'files.preview': 'Vista previa',
                'files.previewFile': 'Vista previa de archivo',
                'files.previewUnavailable': 'No se puede mostrar la vista previa.',
                'files.previewLoading': 'Cargando vista previa…',
                'files.openPreview': 'Vista previa',
                'files.downloadFile': 'Descargar archivo',
                'files.downloadFailed': 'No se pudo descargar el archivo. Comprobá la conexión y la sesión, e intentá de nuevo.',
                'files.closePreview': 'Cerrar vista previa',
                'files.unsupportedPreview': 'Vista previa no disponible para este tipo de archivo. Podés ver los datos o descargar el archivo.',
                'files.pdfPreviewHelp': 'Tu navegador no muestra el PDF embebido. Usá el botón para descargarlo.',
                'files.labelFileType': 'Tipo',
                'files.previewForbidden': 'No tenés permiso para previsualizar este archivo.',
                'files.previewNotFound': 'El archivo no está disponible o ya no lo ves en tu cuenta.',
                'settings.heading': "Configuración",
                'settings.dashboard': 'Dashboard',
                'settings.dashboardDescription': 'Preferencias locales del panel inicial y de los bloques visibles.',
                'settings.dashboardGridHeading': 'Bloques del panel',
                'settings.dashboardShowOnStartDescription': 'Si está activo, al iniciar sesión se abre el panel en lugar de la lista de contactos.',
                'settings.dashboardBlockWelcome': 'Bienvenida',
                'settings.dashboardBlockUsage': 'Uso del plan',
                'settings.dashboardBlockFiles': 'Mis archivos',
                'settings.dashboardBlockPromotions': 'Promociones',
                'settings.dashboardBlockSessions': 'Sesiones activas',
                'settings.dashboardWelcomeDescription': 'Primeros pasos, invitar contacto y accesos de ayuda.',
                'settings.dashboardUsageDescription': 'Uso frente a límites: contactos, caracteres, almacenamiento y dispositivos.',
                'settings.dashboardFilesDescription': 'Resumen de archivos visibles y espacio en Mis archivos.',
                'settings.dashboardPromotionsDescription': 'Resumen de promociones y enlace al programa.',
                'settings.dashboardSessionsDescription': 'Sesiones y dispositivos activos; podés cerrar otras sesiones si aplica.',
                'settings.enabled': 'Activo',
                'settings.disabled': 'Inactivo',
                'settings.showDashboardOnStart': 'Mostrar el Dashboard al ingresar',
                'settings.showWelcomeBlock': 'Mostrar bloque de bienvenida',
                'settings.showPromotionsBlock': 'Mostrar bloque de promociones',
                'settings.showUsageBlock': 'Mostrar bloque de uso del plan',
                'settings.showRecentConversationsBlock': 'Mostrar conversaciones recientes (último mensaje por contacto)',
                'settings.showSessionsBlock': 'Mostrar bloque de sesiones activas',
                'settings.showFilesBlock': 'Mostrar bloque de mis archivos',
                'settings.dashboardLocalNote': 'Estas preferencias se guardan en este navegador (local) de forma temporal hasta contar con API de perfil.',
                'settings.appearanceSettings': "Apariencia",
                'settings.argentinaTheme': "Tema Argentina",
                'settings.darkMode': "Modo oscuro",
                'settings.language': "Idioma",
                'settings.messageSound': "Sonido de mensajes",
                'settings.playSoundDescription': "Reproducir sonido cuando lleguen mensajes o alertas importantes.",
                'settings.webPushSection': 'Notificaciones del sistema (push / PWA)',
                'settings.webPushDescription':
                  'Permite avisos cuando la app está en segundo plano o cerrada en móvil. Requiere clave pública VAPID en el build (VITE_VAPID_PUBLIC_KEY) y claves en el servidor. Activa el permiso del navegador y registra este dispositivo.',
                'settings.webPushButton': 'Activar notificaciones push',
                'settings.webPushRegistering': 'Registrando…',
                'settings.webPushState.granted':
                  'Permiso concedido. Si VAPID está bien configurado, el registro se envió al servidor.',
                'settings.webPushState.denied':
                  'Permiso denegado. Habilite notificaciones para este sitio en los ajustes del navegador.',
                'settings.webPushState.default': 'Toque el botón para solicitar permiso y registrar el dispositivo.',
                'settings.webPushState.unsupported': 'Este navegador no admite notificaciones push.',
                'settings.webPushVapidMissing':
                  'Falta VITE_VAPID_PUBLIC_KEY en este frontend build: no se puede completar la suscripción push.',
                'settings.messageSoundEnabled': "Activado",
                'settings.messageSoundDisabled': "Desactivado",
                'settings.unreadEmailReminderSection': "Resumen por correo de no leídos",
                'settings.unreadEmailReminderDescription': "Si dejas sin leer mensajes o archivos nuevos más tiempo del indicado abajo, ArChat te envía un solo correo resumen (no uno por cada mensaje).",
                'settings.unreadEmailReminderToggle': "Enviarme resúmenes por correo de actividad no leída",
                'settings.unreadEmailDelayHours': "Espera antes de enviar (horas)",
                'settings.unreadEmailDelayHint': "Entre 1 y 168 horas (hasta una semana). El correo usa el idioma de tu perfil.",
                'settings.accountSettings': "Cuenta",
                'settings.deleteAccount': "Eliminar cuenta",
                'settings.deleteAccountWarning': "Esta acción es permanente. Se eliminarán tus datos, mensajes, contactos y preferencias, según el proceso de baja de la plataforma.",
                'settings.deleteMyAccount': "Eliminar mi cuenta",
                'subjects.title': 'Asuntos',
                'subjects.singular': 'Asunto',
                'subjects.plural': 'Asuntos',
                'subjects.general': 'General',
                'subjects.new': 'Nuevo asunto',
                'subjects.create': 'Crear asunto',
                'subjects.rename': 'Renombrar',
                'subjects.finish': 'Finalizar',
                'subjects.reopen': 'Reabrir',
                'subjects.select': 'Continuar',
                'subjects.status.open': 'Abierto',
                'subjects.status.pending': 'Pendiente',
                'subjects.status.finished': 'Finalizado',
                'subjects.limitReached': 'Alcanzaste el límite de asuntos activos en esta conversación. Finalizá un asunto para crear otro.',
                'subjects.limitReachedFree': 'Tu plan FREE permite hasta 3 asuntos activos. Finalizá un asunto para crear otro.',
                'subjects.limitReachedPro': 'Tu plan permite hasta 5 asuntos activos. Finalizá un asunto para crear otro.',
                'subjects.limitReachedFoundation': 'Tu plan permite hasta 5 asuntos activos. Finalizá un asunto para crear otro.',
                'subjects.activeLimitsLine': 'Asuntos activos: {current} / {max}',
                'subjects.closedListTitle': 'Asuntos cerrados',
                'subjects.viewClosed': 'Ver asuntos cerrados',
                'subjects.noClosedSubjects': 'No hay asuntos cerrados.',
                'subjects.reopenSubject': 'Reabrir',
                'subjects.reopenedSubjects': 'Asuntos reabiertos',
                'subjects.reopenLimitReached':
                  'Alcanzaste el límite de asuntos activos. Finalizá otro asunto para reabrir este.',
                'subjects.ownerOnlyReopen': 'Solo quien creó el asunto puede reabrirlo.',
                'subjects.modal.title': 'Asuntos de la conversación',
                'subjects.modal.subtitle': 'Elegí o gestioná los asuntos de esta conversación.',
                'subjects.contactLabel': 'CONTACTO:',
                'subjects.ownerOnlyRename': 'Solo quien creó el asunto puede cambiar el nombre.',
                'subjects.ownerOnlyStateChange': 'Solo quien creó el asunto puede cambiar el estado.',
                'subjects.createdByOther': 'Este asunto fue creado por la otra parte. Podés responder, pero no cambiar su nombre.',
                'subjects.empty': 'No hay asuntos para mostrar.',
                'subjects.noResults': 'No se encontraron asuntos.',
                'subjects.error.generic': 'No pudimos completar la acción. Intentá de nuevo.',
                'subjects.error.featureDisabled': 'Los asuntos no están disponibles en este entorno.',
                'subjects.error.duplicateName': 'Ya existe un asunto activo con ese nombre.',
                'subjects.error.ownerRequired': 'No tenés permiso para modificar este asunto.',
                'subjects.error.defaultCannotRename': 'El asunto General no se puede renombrar.',
                'subjects.error.defaultCannotFinish': 'El asunto General no se puede finalizar.',
                'subjects.current': 'Asunto',
                'subjects.change': 'Cambiar asunto',
                'subjects.currentLabel': 'Asunto:',
                'subjects.changeSubject': 'Cambiar asunto',
                'subjects.closedCannotSend': 'Este asunto está finalizado. Reabrilo para enviar nuevos mensajes.',
                'subjects.selectBeforeSend': 'Elegí un asunto en el modal para ver los mensajes y enviar.',
                'subjects.loadingMessages': 'Cargando mensajes del asunto…',
                'subjects.messageFilterError': 'No pudimos cargar los mensajes para este asunto.',
                'subjects.searchTitle': 'Buscar en asuntos',
                'subjects.searchPlaceholder': 'Buscar en asuntos...',
                'tags.etiquetas': 'etiquetas',
                'tags.manageTitle': 'Administrar etiquetas',
                'tags.manage': '🏷️ Etiquetas',
                'tags.allTags': 'Todas las etiquetas',
                'tags.confirmDelete': '¿Eliminar esta etiqueta?',
                'tags.tagNamePlaceholder': 'Nombre de etiqueta',
                'tags.create': 'Crear',
                'tags.noTags': 'No hay etiquetas. Creá una arriba.',
                'tags.save': 'Guardar',
                'tags.edit': 'Editar',
                'tags.delete': 'Eliminar',
                'tags.assignTo': 'Asignar a',
                'tags.noTagsToAssign': 'No hay etiquetas disponibles. Crealas primero.',
                'tags.bgColor': 'Color de fondo',
                'tags.textColor': 'Color de texto',
                'tags.selectTag': 'Seleccionar una etiqueta',
                'templates.selectTitle': 'Plantillas',
                'templates.noTemplates': 'No hay plantillas. Creá una arriba.',
                'templates.manage': 'Administrar plantillas',
                'templates.confirmDelete': '¿Eliminar esta plantilla?',
                'templates.manageTitle': 'Administrar plantillas',
                'templates.titlePlaceholder': 'Título de la plantilla',
                'templates.bodyPlaceholder': 'Escribí el mensaje de la plantilla...',
                'templates.create': 'Crear plantilla',
                'templates.save': 'Guardar',
                'templates.edit': 'Editar',
                'templates.delete': 'Eliminar',
                ...PRESET_LOCALES.es,
};
